// Translations for NKT - Teklif Hazırla
export const translations = {
  tr: {
    // Landing Page
    professionalSystem: "Profesyonel Teklif Sistemi",
    forWhomTitle: "Kimler İçin?",
    forWhomDesc: "Mimari projeler, iç mimarlık ve dekorasyon işleri, tadilat ve inşaat teklifleri için tek platform.",
    audArchitects: "Mimarlar",
    audInterior: "İç Mimarlar",
    audDecorators: "Dekorasyoncular",
    audContractors: "Tadilat & İnşaat Firmaları",
    audCraftsmen: "Ustalar & Zanaatkârlar",
    appTitle: "NKT - Teklif",
    appSubtitle: "Hazırla",
    appDescription: "Mimarlar, iç mimarlar ve dekorasyoncular için teklif programı: malzeme, işçilik, KDV ve iskonto hesaplamalarıyla dakikalar içinde profesyonel PDF teklifler oluşturun.",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    or: "veya",
    loginWithGoogle: "Google ile Giriş Yap",
    microCTA: "60 saniyede ilk teklifini oluştur",
    galleryTitle: "Örnek Teklifler",
    galleryDesc: "Kullanıcılarımızın hazırladığı gerçek teklif örnekleri",
    galleryBadge: "PDF Örnek",
    galleryProject1: "Villa Tadilat",
    galleryProject2: "Ofis Yenileme",
    galleryProject3: "Çatı Montajı",
    galleryScope1: "Salon · Mutfak · Banyo",
    galleryScope2: "Zemin · Boya · Elektrik",
    galleryScope3: "Panel · Sac · Oluk",
    galleryMaterial: "Malzeme",
    galleryLabor: "İşçilik",
    galleryVat: "KDV %20",
    galleryTotal: "Genel Toplam",
    galleryCurrency: "₺",
    
    // Login Modal
    loginTitle: "Giriş Yap",
    loginSubtitle: "Hesabınıza giriş yapın",
    email: "E-posta",
    password: "Şifre",
    forgotPassword: "Şifremi Unuttum",
    loggingIn: "Giriş yapılıyor...",
    cancel: "İptal",
    
    // Register Modal
    registerTitle: "Kayıt Ol",
    registerSubtitle: "Yeni hesap oluşturun",
    fullName: "Ad Soyad",
    passwordConfirm: "Şifre Tekrar",
    minChars: "En az 6 karakter",
    registering: "Kaydediliyor...",
    profilePicture: "Profil Resmi",
    maxFileSize: "Maksimum 2MB",
    
    // Forgot Password Modal
    forgotPasswordTitle: "Şifremi Unuttum",
    forgotPasswordSubtitle: "E-posta adresinize şifre sıfırlama bağlantısı göndereceğiz",
    sendLink: "Bağlantı Gönder",
    sending: "Gönderiliyor...",
    backToLogin: "Giriş'e Dön",
    
    // Dashboard
    panel: "Panel",
    dashboardOverview: "Teklif durumunuza genel bakış",
    totalProposals: "Toplam Teklif",
    approved: "Onaylanan",
    pending: "Bekleyen",
    awaitingResponse: "Cevap Bekleyen",
    totalRevenue: "Toplam Gelir",
    monthlyProposals: "Aylık Teklifler",
    statusSummary: "Durum Özeti",
    draft: "Taslak",
    sent: "Gönderildi",
    rejected: "Reddedildi",
    pendingRevenue: "Bekleyen Gelir",
    recentProposals: "Son Teklifler",
    viewAll: "Tümünü Gör",
    noProposalsYet: "Henüz teklif yok",
    createFirstProposal: "İlk Teklifinizi Oluşturun",
    myProposals: "Tekliflerim",
    newProposal: "Yeni Teklif",
    noProposals: "Henüz teklif oluşturmadınız",
    startFirstProposal: "Hemen ilk teklifinizi oluşturmaya başlayın",
    createProposal: "Teklif Oluştur",
    edit: "Düzenle",
    delete: "Sil",
    material: "Malzeme",
    labor: "İşçilik",
    kdv: "KDV",
    statusUpdateFailed: "Durum güncellenemedi",
    statusUpdated: "Durum güncellendi",
    
    // OCR - Image to Text
    scanImage: "Görsel Tara",
    scanImageDesc: "El yazısı tekliflerinizi yapay zeka ile dijitale dönüştürün",
    uploadImage: "Görsel Yükle",
    scanning: "Taranıyor...",
    scanComplete: "Tarama tamamlandı",
    scanFailed: "Tarama başarısız",
    extractedText: "Çıkarılan Metin",
    useThisText: "Bu Metni Kullan",
    textEditor: "Metin Düzenleyici",
    clearText: "Metni Temizle",
    
    // Settings Page
    settings: "Ayarlar",
    profileSettings: "Profil Ayarları",
    profileDescription: "Kişisel bilgilerinizi güncelleyin",
    changePassword: "Şifre Değiştir",
    passwordDescription: "Hesap güvenliğiniz için şifrenizi güncelleyin",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmNewPassword: "Yeni Şifre (Tekrar)",
    updatePassword: "Şifreyi Güncelle",
    saveChanges: "Değişiklikleri Kaydet",
    saving: "Kaydediliyor...",
    profileUpdated: "Profil güncellendi!",
    passwordChanged: "Şifre değiştirildi!",
    passwordMismatch: "Şifreler eşleşmiyor!",
    passwordTooShort: "Şifre en az 6 karakter olmalı!",
    dangerZone: "Tehlikeli Bölge",
    dangerDescription: "Bu işlemler geri alınamaz",
    deleteAccount: "Hesabı Sil",
    deleteAccountWarning: "Hesap silme için destek ile iletişime geçin",
    phone: "Telefon",
    company: "Firma Adı",
    address: "Adres",
    commission: "Komisyon",
    total: "Toplam",
    logout: "Çıkış Yap",
    
    // Proposal Editor
    editProposal: "Teklif Düzenle",
    newProposalTitle: "Yeni Teklif",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    
    // General Info
    generalInfo: "Genel Bilgiler",
    projectTitle: "Proje Başlığı",
    customerName: "Müşteri Adı",
    customerPhone: "Müşteri Telefonu",
    customerEmail: "Müşteri E-posta",
    customerAddress: "Müşteri Adresi",
    companyName: "Firma Adı",
    companyLogo: "Firma Logosu",
    
    // Materials & Labor
    materials: "Malzemeler",
    laborItems: "İşçilik",
    addMaterial: "Malzeme Ekle",
    addLabor: "İşçilik Ekle",
    itemName: "Kalem Adı",
    quantity: "Miktar",
    unit: "Birim",
    unitPrice: "Birim Fiyat",
    images: "Resimler",
    
    // Summary
    summary: "Özet",
    subtotal: "Ara Toplam",
    kdvRate: "KDV Oranı",
    commissionRate: "Komisyon Oranı",
    grandTotal: "Genel Toplam",
    
    // Terms & Bank
    termsAndConditions: "Şartlar ve Koşullar",
    paymentTerms: "Ödeme Koşulları",
    validityPeriod: "Geçerlilik Süresi",
    notes: "Notlar",
    bankInfo: "Banka Bilgileri",
    accountHolder: "Hesap Sahibi",
    bankName: "Banka Adı",
    iban: "IBAN",
    
    // Messages
    loginSuccess: "Giriş başarılı!",
    loginFailed: "Giriş yapılamadı",
    registerSuccess: "Kayıt başarılı!",
    registerFailed: "Kayıt yapılamadı",
    passwordMismatch: "Şifreler eşleşmiyor!",
    passwordMinLength: "Şifre en az 6 karakter olmalıdır",
    proposalSaved: "Teklif kaydedildi",
    proposalDeleted: "Teklif silindi",
    pdfDownloaded: "PDF indirildi",
    jpgDownloaded: "JPG indirildi",
    downloadFailed: "İndirme başarısız",
    
    // PDF Export Labels
    pdfCustomerInfo: "Müşteri bilgileri",
    pdfCompanyInfo: "Firma bilgileri",
    pdfCustomerName: "müşteri adı",
    pdfPhone: "telefon",
    pdfAddress: "adres",
    pdfEmail: "e-posta",
    pdfCompanyName: "firma adı",
    pdfWebsite: "web sitesi",
    pdfMaterialCosts: "Malzeme Bedelleri",
    pdfLaborCosts: "İşçilik Bedelleri",
    pdfImage: "Resim",
    pdfMaterialDesc: "Malzeme / Açıklama",
    pdfLaborDesc: "İşçilik / Açıklama",
    pdfCategory: "Kategori",
    pdfUnit: "Birim",
    pdfUnitPrice: "Birim Fiyatı",
    pdfTotal: "Toplam",
    pdfMaterialTotal: "Malzeme Toplamı",
    pdfLaborTotal: "İşçilik Toplamı",
    pdfTermsConditions: "Şartlar ve Koşullar",
    pdfBankInfo: "Banka bilgileri",
    pdfPaymentTerms: "Ödeme Koşulları",
    pdfAccountHolder: "Banka Sahibi",
    pdfValidityPeriod: "Teklif Geçerlilik Süresi",
    pdfBankName: "Banka",
    pdfNotes: "Notlar / Diğer Şartlar",
    pdfIban: "İban",
    pdfSubtotal: "Ara Toplam",
    pdfKdv: "KDV",
    pdfCommission: "Komisyon",
    pdfGrandTotal: "Genel Toplam",
    pdfCompanyLogo: "Firma logosu",
    
    // PWA
    installApp: "Uygulamayı Yükle",
    installDescription: "NKT Teklif'i cihazınıza yükleyerek daha hızlı erişin",
    install: "Yükle",
    notNow: "Şimdi Değil",
    
    // Offline
    backOnline: "İnternet bağlantısı yeniden kuruldu",
    offline: "Çevrimdışı - İnternet bağlantınız yok",
    
    // Language
    language: "Dil",
    selectLanguage: "Dil Seçin",

    // Sidebar
    navHome: "Ana Sayfa",
    searchPlaceholder: "Teklif, müşteri veya belge ara…",
    searching: "Aranıyor…",
    noResults: "Sonuç bulunamadı",
    navProposals: "Teklifler",
    navTextDocs: "Metin Belgeleri",
    navCustomers: "Müşteriler",
    navReports: "Raporlar",
    appTagline: "Hızlı, kolay, profesyonel",
    userFallback: "Kullanıcı",

    // Common
    loading: "Yükleniyor...",
    print: "Yazdır",
    close: "Kapat",
    all: "Tümü",
    actions: "İşlemler",
    dateLabel: "Tarih",
    statusLabel: "Durum",
    amountLabel: "Tutar",
    statusApproved: "Onaylandı",
    downloadPdf: "PDF İndir",
    sendEmailTitle: "E-posta Gönder",
    sendBtn: "Gönder",
    recipientEmail: "Alıcı E-posta",
    recipientName: "Alıcı Adı",
    subjectLabel: "Konu",
    messageOptional: "Mesaj (Opsiyonel)",
    messagePlaceholder: "Özel mesajınız (boş bırakırsanız varsayılan mesaj kullanılır)",
    senderLabel: "Gönderen",
    enterRecipientEmail: "Lütfen alıcı e-posta adresini girin",
    emailSendFailed: "E-posta gönderilemedi",
    deleteFailed: "Silme başarısız",
    updateFailed: "Güncelleme başarısız",
    pdfGenerating: "PDF oluşturuluyor...",
    printPreparing: "Yazdırma hazırlanıyor...",
    printError: "Yazdırma hatası",
    unknownError: "Bilinmeyen hata",
    monthsShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],

    // Proposals page
    proposalsSubtitle: "Tüm tekliflerinizi yönetin",
    proposalsLoadFailed: "Teklifler yüklenemedi",
    confirmDeleteProposal: "Bu teklifi silmek istediğinize emin misiniz?",
    totalAmount: "Toplam Tutar",
    searchProposalPlaceholder: "Teklif veya müşteri ara...",
    statusFilterLabel: "Durum Filtresi",
    sortLabel: "Sıralama",
    sortNewest: "En Yeni",
    sortOldest: "En Eski",
    sortAmountDesc: "Tutar (Yüksek-Düşük)",
    sortAmountAsc: "Tutar (Düşük-Yüksek)",
    sortTitleAZ: "Başlık (A-Z)",
    proposalList: "Teklif Listesi",
    proposalWord: "teklif",
    noProposalsFound: "Henüz teklif bulunmuyor",
    createFirstProposalBtn: "İlk Teklifi Oluştur",
    thProposal: "Teklif",
    thCustomer: "Müşteri",
    untitledProposal: "İsimsiz Teklif",
    sendProposal: "Teklif Gönder",
    sendDocument: "Belge Gönder",
    sendByEmailDesc: "belgesini e-posta ile gönderin",
    subjectProposalPrefix: "Teklif",
    subjectDocumentPrefix: "Belge",
    ocrCreated: "OCR ile oluşturuldu",

    // Customers page
    customersSubtitle: "Müşteri bilgilerinizi yönetin",
    newCustomer: "Yeni Müşteri",
    totalCustomers: "Toplam Müşteri",
    searchCustomerPlaceholder: "Müşteri ara (ad, e-posta, telefon, firma)...",
    noSearchResults: "Arama sonucu bulunamadı",
    noCustomersYet: "Henüz müşteri bulunmuyor",
    addFirstCustomer: "İlk Müşteriyi Ekle",
    editCustomer: "Müşteri Düzenle",
    addNewCustomer: "Yeni Müşteri Ekle",
    customerNameRequired: "Müşteri adı gerekli",
    customerUpdated: "Müşteri güncellendi",
    customerAdded: "Müşteri eklendi",
    customerSaveFailed: "Müşteri kaydedilemedi",
    customerDeleted: "Müşteri silindi",
    customerDeleteFailed: "Müşteri silinemedi",
    confirmDeleteCustomer: "müşterisini silmek istediğinize emin misiniz?",
    companyLabel: "Firma",
    companyOptionalPlaceholder: "Firma adı (opsiyonel)",
    fullNamePlaceholder: "Adı Soyadı",
    fullAddressPlaceholder: "Tam adres",
    customerNotesPlaceholder: "Müşteri hakkında notlar...",
    taxOffice: "Vergi Dairesi",
    taxOfficePlaceholder: "Örn: Kadıköy",
    taxNumber: "Vergi Numarası",
    taxNumberPlaceholder: "10 veya 11 haneli VKN / TCKN",
    tradeTitle: "Ticaret Unvanı",
    tradeTitlePlaceholder: "Şirketin resmi tam unvanı",
    mersisNo: "MERSİS Numarası",
    mersisNoOptional: "MERSİS Numarası (isteğe bağlı)",
    mersisNoPlaceholder: "16 haneli MERSİS numarası",
    website: "Firma Web Sitesi",
    websiteOptional: "Firma Web Sitesi (isteğe bağlı)",
    websitePlaceholder: "https://ornek.com",
    fiscalInfoTitle: "Vergi & Ticari Bilgiler",
    senderEmailLabel: "Yanıt E-posta Adresim (Reply-To)",
    senderEmailHelp: "Teklif alıcısı e-postada 'Yanıtla' butonuna bastığında mesaj bu adrese gelir. Boş bırakırsanız hesabınıza kayıtlı e-posta kullanılır. Not: teklifler info@nktteklif.com üzerinden gönderilir; yanıtlar sizin adresinize düşer.",
    replyToLabel: "Yanıtlar bu adrese gelir",
    ownDomainGuideTitle: "Kendi domaininizden gönder — Resend rehberi",
    ownDomainGuideIntro: "Varsayılan olarak teklifler doğrulanmış info@nktteklif.com adresinden çıkar, yanıtlar sizin adresinize yönlendirilir. Kendi domaininizi (örn. teklif@sirketiniz.com) gerçek 'Gönderen' olarak kullanmak için aşağıdaki adımları izleyin:",
    ownDomainStep1: "resend.com adresine gidin ve ücretsiz hesap açın.",
    ownDomainStep2: "Sol menüden 'Domains' → 'Add Domain' → domaininizi yazın (örn. sirketiniz.com).",
    ownDomainStep3: "Resend size 3 DNS kaydı gösterir (SPF, DKIM, MX). Bu kayıtları domain sağlayıcınızın (GoDaddy, Namecheap, Cloudflare vb.) DNS panelinden ekleyin.",
    ownDomainStep4: "Resend panelinde 'Verify DNS' butonuna basın. Yayılma 5-30 dakika sürebilir.",
    ownDomainStep5: "Doğrulama yeşile döndüğünde bu ayara teklif@sirketiniz.com yazın; teklifler artık gerçekten sizin domaininizden çıkar.",
    ownDomainNote: "Not: Gmail veya Yahoo gibi kişisel adresler doğrulanamaz — sadece sizin sahibi olduğunuz alan adları çalışır. Kurulumda takılırsanız Resend'in DNS Verifier aracını kullanabilirsiniz.",
    ownDomainOpenResend: "Resend'i Aç",
    mailtoGreeting: "Merhaba",
    mailtoBodyIntro: "Talep ettiğiniz teklifi ekte tarafınıza gönderiyorum.",
    mailtoAttachHint: "(PDF dosyası bilgisayarınıza indirildi — bu e-postaya sürükleyip bırakarak ekleyebilirsiniz.)",
    mailtoRegards: "İyi çalışmalar dilerim.",
    dataLoadFailed: "Veriler yüklenemedi",
    createNewProposal: "Yeni Teklif Oluştur",
    proposalsLabel: "Teklifler",

    // Text documents page
    textDocsSubtitle: "OCR ile taranan belgeler",
    newDocument: "Yeni Belge",
    totalDocuments: "Toplam Belge",
    thisMonth: "Bu Ay",
    quickScan: "Hızlı Tarama",
    scanBtn: "Tara",
    searchDocPlaceholder: "Belge ara...",
    noDocumentsYet: "Henüz metin belgesi bulunmuyor",
    createNewDocument: "Yeni Belge Oluştur",
    untitledDocument: "İsimsiz Belge",
    documentsLoadFailed: "Belgeler yüklenemedi",
    confirmDeleteDocument: "Bu belgeyi silmek istediğinize emin misiniz?",
    documentDeleted: "Belge silindi",
    selectImageFile: "Lütfen bir görsel dosyası seçin",
    fileTooBig: "Dosya çok büyük. Maksimum 25MB",
    imageProcessFailed: "Görsel işlenemedi",
    scanningImage: "Görsel taranıyor...",
    scanSuccessRedirect: "Tarama başarılı! Düzenleme sayfasına yönlendiriliyorsunuz...",
    scanEmptyResult: "Tarama sonucu boş. Lütfen daha net bir görsel deneyin.",

    // OCR editor
    textEditorTitle: "Metin Düzenleyici",
    saveAsText: "Text Olarak Kaydet",
    saveToDb: "Veritabanına kaydet",
    downloadAsPdf: "PDF Olarak İndir",
    pdfFormat: "PDF formatında",
    sendToPrinter: "Yazıcıya gönder",
    docInfoTitle: "Belge Bilgileri",
    docNameLabel: "Belge Adı",
    docNamePlaceholder: "Örn: Sözleşme - Villa A",
    enterDocName: "Belge adını girin...",
    textOnlyNote: "* Sadece metin olarak kaydedilir.",
    customerContactInfo: "Müşteri ve İletişim Bilgileri",
    selectCustomerLabel: "Müşteri Seç",
    selectCustomerPlaceholder: "Mevcut müşteri seçin veya yeni ekleyin",
    customerNamePlaceholder: "Müşteri adı ve soyadı",
    customerAddressPlaceholder: "Müşteri adresi",
    fontLabel: "Yazı:",
    boldTitle: "Kalın",
    italicTitle: "İtalik",
    underlineTitle: "Altı Çizili",
    strikeTitle: "Üstü Çizili",
    alignLeftTitle: "Sola",
    alignCenterTitle: "Ortala",
    alignRightTitle: "Sağa",
    newDocBtn: "+ Yeni",
    savedSuffix: "kaydedildi",
    docUpdated: "✓ Belge güncellendi!",
    docSaved: "✓ Belge kaydedildi!",
    saveFailed: "Kaydetme başarısız",
    enterAName: "Lütfen bir isim girin",
    textEmpty: "Metin boş olamaz",
    noContentToPrint: "Yazdırılacak içerik yok",
    noContentForPdf: "PDF oluşturulacak içerik yok",
    printWindowOpened: "Yazdırma penceresi açıldı",
    popupBlocked: "Pop-up engelleyici aktif",
    writeTextHere: "Metni buraya yazın...",
    readyForNewDoc: "Yeni belge için hazır",
    docLoadFailed: "Belge yüklenemedi",
    pdfCreateFailed: "PDF oluşturulamadı",

    // Settings page
    settingsSubtitle: "Firma ve hesap ayarlarınızı yönetin",
    settingsInfoBanner: "Bu bilgiler PDF ve JPG teklif çıktılarının altbilgi (footer) kısmında görüntülenecektir.",
    companyInfoDesc: "Firma bilgilerinizi girin - PDF ve JPG footer'ında görünecek",
    logoNote: "PNG, JPG - Maksimum 2MB",
    websiteLabel: "Web Sitesi",
    letterheadTitle: "Antetli Kağıt",
    letterheadDesc: "Hazır antetli kağıdınızı PNG/JPG olarak yükleyin. Yazılar, ayarladığınız üst ve alt boşluğun arasına yerleşir; yan boşluklar standart 20mm'dir.",
    letterheadImageLabel: "Antetli Kağıt Görseli",
    letterheadNote: "A4 boyutunda PNG / JPG (otomatik sıkıştırılır, max 15MB)",
    removeLetterhead: "Antetli kağıdı kaldır",
    topMarginLabel: "Üst Boşluk (Top)",
    topMarginDesc: "Yazı üstten ne kadar aşağı başlasın",
    bottomMarginLabel: "Alt Boşluk (Bottom)",
    bottomMarginDesc: "Yazı altta ne kadar boşluk bıraksın",
    letterheadNotUploaded: "Antetli kağıt yüklenmedi",
    textAreaLabel: "Yazı alanı",
    textAreaHint: "buraya yerleşir",
    saveSettingsBtn: "Ayarları Kaydet",
    profitMarginTitle: "Kar Marjı",
    profitMarginDesc: "Teklif oluştururken her malzeme ve işçilik kaleminin fiyatına otomatik eklenir. Müşteri çıktılarında (PDF/JPG) ayrı bir satır olarak görünmez. \"0\" ise kar eklenmez.",
    profitMarginRateLabel: "Kar Marjı Oranı (%)",
    saveProfitMarginBtn: "Kar Marjını Kaydet",
    profitMarginExample: "Örnek: 1.000 değerindeki bir kalem, teklifte {amount} olarak hesaplanır.",
    noProfitMargin: "Şu an kar marjı uygulanmıyor.",
    accountInfoTitle: "Hesap Bilgileri",
    forgetMeBtn: "Beni Unut (Ortak Bilgisayar)",
    forgetMeNote: "\"Beni Unut\": Başkasının bilgisayarından giriş yaptıysanız bunu kullanın — Google oturumunuz da o cihazdan kapatılır ve bir sonraki girişte hesap yeniden sorulur.",
    forgetMeConfirm: "Beni Unut: Uygulamadan çıkış yapılır VE bu cihazdaki Google oturumlarınız kapatılır.\n\nBaşkasının/ortak bilgisayarında kullanıyorsanız bunu seçin — bir sonraki Google girişinde hesap bilgileri yeniden sorulur.\n\nDevam edilsin mi?",
    settingsSaved: "Ayarlar kaydedildi! PDF ve JPG dışa aktarmalarında kullanılacak.",
    settingsSaveFailed: "Ayarlar kaydedilemedi: ",
    logoTooBig: "Logo dosyası 5MB'dan küçük olmalı",
    logoPreparing: "Logo hazırlanıyor...",
    logoProcessFailed: "Logo işlenemedi: ",
    imagePreparing: "Görsel hazırlanıyor...",
    imageUploaded: "Görsel yüklendi",
    imageTooBig: "Görsel 15MB'dan küçük olmalı",
    imageTooLargeError: "Yüklenen görsel(ler) çok büyük. Lütfen daha küçük bir antetli kağıt görseli (max 2-3MB orijinal dosya) deneyin.",
    passwordChangedSuccess: "Şifre başarıyla değiştirildi!",
    passwordChangeError: "Şifre değiştirme hatası",

    // Proposal editor
    editProposalDesc: "Mevcut teklifi düzenleyin",
    newProposalDesc: "Yeni bir teklif oluşturun",
    readyTemplate: "Hazır Teklif",
    readyTemplates: "Hazır Şablonlar",
    myTemplates: "Şablonlarım",
    saveAsTemplateMenu: "Bu Teklifi Şablon Olarak Kaydet",
    materialsLowerWord: "malzeme",
    laborLowerWord: "işçilik",
    downloadingBtn: "İndiriliyor...",
    shareWhatsAppLabel: "WhatsApp",
    shareWhatsAppTitle: "WhatsApp ile PDF paylaş",
    backToHomeTitle: "Ana sayfaya dön",
    projectProposalInfo: "Proje ve Teklif Bilgileri",
    projectTitlePlaceholder: "Örn: Konut Projesi - Villa A",
    proposalStatusLabel: "Teklif Durumu",
    selectStatusPlaceholder: "Durum seçin",
    callLabel: "Ara",
    materialCostTab: "Malzeme Bedeli",
    laborCostTab: "İşçilik Bedeli",
    addImagesTab: "Görsel Ekle",
    noMaterialsYet: "Henüz malzeme eklenmedi",
    noLaborYet: "Henüz işçilik eklenmedi",
    materialNameLabel: "Malzeme Adı",
    roomLabel: "Oda / Bölüm (isteğe bağlı)",
    roomPlaceholder: "Örn: Yatak Odası, Mutfak, Balkon",
    ungroupedRoom: "Genel",
    inProposalSearchPlaceholder: "Bu teklifte ara: malzeme, işçilik veya oda…",
    materialNamePlaceholder: "Örn: Seramik Kaplama",
    descriptionLabel: "Açıklama",
    descriptionPlaceholder: "Detaylı açıklama",
    imagesMultiLabel: "Resimler (Birden fazla seçebilirsiniz)",
    materialTotalLabel: "Malzeme Toplam:",
    laborTotalLabel: "İşçilik Toplam:",
    laborNameLabel: "İşçilik Adı",
    laborNamePlaceholder: "Örn: Seramik Döşeme",
    attachmentsTitle: "Görseller ve Ekler",
    attachmentsDesc: "Resim, PDF, CAD — her türlü dosya eklenebilir. Görseller PDF çıktısında isim ve bilgisiyle yer alır, ekli PDF'ler çıktının sonuna eklenir.",
    uploadingBtn: "Yükleniyor...",
    addAttachmentBtn: "Görsel / Dosya Ekle",
    noAttachmentsYet: "Henüz dosya eklenmedi. \"Görsel / Dosya Ekle\" ile resim, PDF veya CAD dosyaları seçin (çoklu seçim desteklenir).",
    attachmentNameLabel: "Görsel Adı",
    attachmentInfoLabel: "Bilgi / Açıklama",
    attachmentInfoPlaceholder: "Örn: Ön cephe görünümü",
    kdvDiscountTitle: "KDV ve İskonto",
    kdvRateLabel: "KDV Oranı (%)",
    kdvAmountLabel: "KDV Tutarı:",
    discountRateLabel: "İskonto Oranı (%)",
    discountAmountLabel: "İskonto Tutarı:",
    discountWord: "İskonto",
    profitIncludedTemplate: "Kar marjı (%{pm}) fiyatlara dahil",
    invisibleToCustomer: "müşteriye görünmez",
    subtotalColon: "Ara Toplam:",
    paymentTermsPlaceholder: "Örn: %50 Peşin, %50 Teslimatta",
    validityPlaceholder: "Örn: 30 gün",
    notesOtherTerms: "Notlar / Diğer Şartlar",
    notesPlaceholder: "Ek açıklamalar veya şartlar...",
    accountHolderPlaceholder: "Hesap sahibinin adı",
    bankNamePlaceholder: "Örn: Ziraat Bankası",
    grandTotalCaps: "GENEL TOPLAM:",
    tplDialogTitle: "Şablon Olarak Kaydet",
    tplNameLabel: "Şablon Adı",
    tplNamePlaceholder: "Örn: Standart Banyo Tadilatı",
    tplSaveNote: "Mevcut {m} malzeme ve {l} işçilik kalemi şablona kaydedilecek. Daha sonra \"Hazır Teklif\" menüsünden tek tıkla ekleyebilirsiniz.",
    giveUpBtn: "Vazgeç",
    enterTitleCustomer: "Lütfen başlık ve müşteri adını girin",
    proposalUpdated: "Teklif güncellendi",
    proposalCreated: "Teklif oluşturuldu",
    proposalSaveFailed: "Teklif kaydedilemedi",
    proposalLoadFailed: "Teklif yüklenemedi",
    templateAdded: "\"{name}\" şablonu eklendi — miktar ve fiyatları düzenleyebilirsiniz",
    templateNameRequired: "Lütfen şablon adı girin",
    noItemsForTemplate: "Şablona kaydedilecek kalem yok",
    templateSaved: "Şablon kaydedildi",
    templateSaveFailed: "Şablon kaydedilemedi",
    templateDeleted: "Şablon silindi",
    templateDeleteFailed: "Şablon silinemedi",
    imagesUploaded: "{n} resim yüklendi",
    imageUploadFailed: "Resim yüklenemedi",
    imageDeleted: "Resim silindi",
    filesAdded: "{n} dosya eklendi",
    fileUploadFailed: "Dosya yüklenemedi",
    fileRemoved: "Dosya kaldırıldı",

    // Reports page
    reportsTitle: "Raporlar",
    reportsSubtitle: "Teklif ve gelir istatistikleriniz",
    approvalRate: "Onay Oranı",
    approvedRevenue: "Onaylanan Ciro",
    pendingColon: "Bekleyen:",
    estimatedProfit: "Tahmini Kâr",
    profitVisibilityNote: "Kar marjından — sadece size görünür",
    monthlyChartTitle: "Aylık Teklif & Ciro (Son 12 Ay)",
    statusDistribution: "Durum Dağılımı",
    topCategoriesTitle: "En Çok Kullanılan Kategoriler",
    noCategoryData: "Henüz kategori verisi yok",
    itemsWord: "kalem",
    topCustomersTitle: "Müşteri Bazlı Ciro (İlk 10)",
    noCustomerData: "Henüz müşteri verisi yok",
    reportsLoadFailed: "Rapor verileri yüklenemedi",

    // Smart fields
    categoryLabel: "Kategori",
    selectCategoryPlaceholder: "Kategori seçin",
    subCategoryLabel: "Alt Başlık",
    selectSubCategoryPlaceholder: "Alt başlık seçin",
    detailLabel: "Detay / Özellik",
    selectDetailPlaceholder: "Detay seçin",
    measureCalcLabel: "Ölçü ile Hesapla (metre)",
    widthLabel: "En",
    lengthLabel: "Boy",
    heightLabel: "Yükseklik",
    heightOptLabel: "Yükseklik (ops.)",
    autoTransferred: "Miktara otomatik aktarıldı",
    hideCalcTable: "Hesaplama Tablosunu Gizle",
    getPriceBtn: "Fiyat Al",
    gettingPrice: "Fiyat alınıyor...",
    enterItemFirst: "Önce kalem adı girin veya kategori seçin",
    aiPriceFailed: "AI fiyat tahmini alınamadı, lütfen tekrar deneyin",
    noPriceToApply: "Uygulanacak fiyat bulunamadı",
    priceApplied: "Birim fiyat uygulandı",
    applyMaterialBtn: "Malzemeyi Uygula",
    applyLaborBtn: "İşçiliği Uygula",
    avgLabel: "Ort",

    // Reset password
    newPasswordTitle: "Yeni Şifre Belirle",
    newPasswordDesc: "Hesabınız için yeni bir şifre oluşturun",
    invalidLink: "Geçersiz Link",
    invalidLinkDesc: "Şifre sıfırlama linki geçersiz veya eksik. Lütfen tekrar şifre sıfırlama talebinde bulunun.",
    backToHome: "Ana Sayfaya Dön",
    changePasswordBtn: "Şifreyi Değiştir",
    passwordResetSuccess: "Şifreniz başarıyla değiştirildi!",
    passwordResetFailed: "Şifre sıfırlama başarısız. Link geçersiz veya süresi dolmuş olabilir.",

    // Landing extras
    featureMaterialTitle: "Malzeme Yönetimi",
    featureMaterialDesc: "Detaylı malzeme listesi, birim fiyatlar, görseller ve otomatik toplam hesaplama.",
    featureLaborTitle: "İşçilik & KDV",
    featureLaborDesc: "İşçilik bedelleri, KDV hesaplamaları ve komisyon yönetimi tek platformda.",
    featurePdfTitle: "PDF Export",
    featurePdfDesc: "Profesyonel PDF çıktıları, firma logosu ve müşteri bilgileriyle hazır.",
    footerDesc: "Profesyonel teklif hazırlama platformu. Malzeme, işçilik ve maliyet hesaplamalarınızı kolayca yapın.",
    footerRights: "© 2025 NKT Tasarım. Tüm hakları saklıdır.",
    helpTitle: "Yardım",
    contactUs: "Bize Ulaşın",
    faqLink: "Sıkça Sorulan Sorular",
    supportLink: "Destek",
    termsLink: "Şartlar & Koşullar",
    servicesTitle: "Hizmetler",
    serviceLaborKdv: "İşçilik & KDV Hesaplama",
    serviceCost: "Maliyet Hesaplama",
    servicePdfJpg: "PDF & JPG Export",
    communityTitle: "Topluluk",
    footerSlogan: "Tasarım ve Dekorasyon Projeleriniz İçin Güvenilir Çözüm Ortağınız",
    resetLinkSentKnown: "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi",
    resetLinkSentGeneric: "E-posta adresi kayıtlıysa şifre sıfırlama bağlantısı gönderildi",
    genericError: "Bir hata oluştu",
    imageTooBig2MB: "Resim 2MB'dan küçük olmalı",

    // Auth & misc extras
    optionalWord: "(opsiyonel)",
    loginErrCreds: "E-posta veya şifre hatalı. Şifrenizi unuttuysanız 'Şifremi Unuttum' bağlantısını kullanın.",
    loginErrNotFound: "Bu e-posta adresi ile kayıtlı kullanıcı bulunamadı. Lütfen önce 'Kayıt Ol' kısmından kayıt olun.",
    loginErrNetwork: "Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin ya da kısa süre sonra tekrar deneyin.",
    loginErrGeneric: "Giriş yapılamadı",
    authSessionNotFound: "Oturum bulunamadı",
    authFailed: "Kimlik doğrulama başarısız oldu",
    authenticating: "Kimlik doğrulanıyor...",
    authNotMe: "Bu ben değilim — farklı hesapla gir",
    authNotMeNote: "\"Bu ben değilim\" seçilirse bu cihazdaki Google oturumu kapatılır ve bir sonraki girişte hesap bilgileri yeniden sorulur.",
    qtyApplied: "Miktar uygulandı",
    calcEnterHint: "Hesap için ölçüleri girin — sonuçlar otomatik görünecek",
    pdfOpenedPrintHint: "PDF açıldı. Tarayıcı menüsünden yazdırabilirsiniz.",
    applyBtn: "Uygula",
    applyToQuantity: "Miktara Uygula",
    authContinueQuestion: "Bu hesapla devam etmek istiyor musunuz?",
    authContinueYes: "Evet, Devam Et",
    wallAreaFormula: "Duvar alanı = 2×(En+Boy)×Yükseklik",
    termsConditions: "Şartlar ve Koşullar",
    singleWallFormula: "Tek duvar = En×Yükseklik",
    floorAreaFormula: "Zemin alanı = En×Boy"
  },
  
  en: {
    professionalSystem: "Professional Bid System",
    forWhomTitle: "Who Is It For?",
    forWhomDesc: "One platform for architectural projects, interior design and decoration work, renovation and construction bids.",
    audArchitects: "Architects",
    audInterior: "Interior Designers",
    audDecorators: "Decorators",
    audContractors: "Renovation & Construction Companies",
    audCraftsmen: "Craftsmen & Tradespeople",
    appTitle: "NKT - Bid",
    appSubtitle: "Builder",
    appDescription: "Bid software for architects, interior designers and decorators: create professional PDF bids in minutes with material, labor, VAT and discount calculations.",
    login: "Login",
    register: "Register",
    or: "or",
    loginWithGoogle: "Login with Google",
    microCTA: "Create your first proposal in 60 seconds",
    galleryTitle: "Sample Proposals",
    galleryDesc: "Real proposal examples created by our users",
    galleryBadge: "PDF Sample",
    galleryProject1: "Villa Renovation",
    galleryProject2: "Office Refresh",
    galleryProject3: "Roof Installation",
    galleryScope1: "Living · Kitchen · Bath",
    galleryScope2: "Floor · Paint · Electric",
    galleryScope3: "Panel · Sheet · Gutter",
    galleryMaterial: "Materials",
    galleryLabor: "Labor",
    galleryVat: "VAT 20%",
    galleryTotal: "Grand Total",
    galleryCurrency: "$",
    
    loginTitle: "Login",
    loginSubtitle: "Sign in to your account",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot Password",
    loggingIn: "Logging in...",
    cancel: "Cancel",
    
    registerTitle: "Register",
    registerSubtitle: "Create a new account",
    fullName: "Full Name",
    passwordConfirm: "Confirm Password",
    minChars: "At least 6 characters",
    registering: "Registering...",
    profilePicture: "Profile Picture",
    maxFileSize: "Maximum 2MB",
    
    forgotPasswordTitle: "Forgot Password",
    forgotPasswordSubtitle: "We will send a password reset link to your email",
    sendLink: "Send Link",
    sending: "Sending...",
    backToLogin: "Back to Login",
    
    // Dashboard
    panel: "Panel",
    dashboardOverview: "Overview of your bids",
    totalProposals: "Total Bids",
    approved: "Approved",
    pending: "Pending",
    awaitingResponse: "Awaiting Response",
    totalRevenue: "Total Revenue",
    monthlyProposals: "Monthly Bids",
    statusSummary: "Status Summary",
    draft: "Draft",
    sent: "Sent",
    rejected: "Rejected",
    pendingRevenue: "Pending Revenue",
    recentProposals: "Recent Bids",
    viewAll: "View All",
    noProposalsYet: "No bids yet",
    createFirstProposal: "Create Your First Bid",
    myProposals: "My Bids",
    newProposal: "New Bid",
    noProposals: "You haven't created any bids yet",
    startFirstProposal: "Start creating your first bid now",
    createProposal: "Create Bid",
    edit: "Edit",
    delete: "Delete",
    material: "Material",
    labor: "Labor",
    kdv: "VAT",
    commission: "Commission",
    total: "Total",
    logout: "Logout",
    statusUpdateFailed: "Status update failed",
    statusUpdated: "Status updated",
    
    // OCR - Image to Text
    scanImage: "Scan Image",
    scanImageDesc: "Convert handwritten bids to digital with AI",
    uploadImage: "Upload Image",
    scanning: "Scanning...",
    scanComplete: "Scan complete",
    scanFailed: "Scan failed",
    extractedText: "Extracted Text",
    useThisText: "Use This Text",
    textEditor: "Text Editor",
    clearText: "Clear Text",
    
    editProposal: "Edit Bid",
    newProposalTitle: "New Bid",
    save: "Save",
    saving: "Saving...",
    
    generalInfo: "General Information",
    projectTitle: "Project Title",
    customerName: "Customer Name",
    customerPhone: "Customer Phone",
    customerEmail: "Customer Email",
    customerAddress: "Customer Address",
    companyName: "Company Name",
    companyLogo: "Company Logo",
    
    materials: "Materials",
    laborItems: "Labor",
    addMaterial: "Add Material",
    addLabor: "Add Labor",
    itemName: "Item Name",
    quantity: "Quantity",
    unit: "Unit",
    unitPrice: "Unit Price",
    images: "Images",
    
    summary: "Summary",
    subtotal: "Subtotal",
    kdvRate: "VAT Rate",
    commissionRate: "Commission Rate",
    grandTotal: "Grand Total",
    
    termsAndConditions: "Terms & Conditions",
    paymentTerms: "Payment Terms",
    validityPeriod: "Validity Period",
    notes: "Notes",
    bankInfo: "Bank Information",
    accountHolder: "Account Holder",
    bankName: "Bank Name",
    iban: "IBAN",
    
    loginSuccess: "Login successful!",
    loginFailed: "Login failed",
    registerSuccess: "Registration successful!",
    registerFailed: "Registration failed",
    passwordMismatch: "Passwords do not match!",
    passwordMinLength: "Password must be at least 6 characters",
    proposalSaved: "Bid saved",
    proposalDeleted: "Bid deleted",
    pdfDownloaded: "PDF downloaded",
    jpgDownloaded: "JPG downloaded",
    downloadFailed: "Download failed",
    
    // PDF Export Labels
    pdfCustomerInfo: "Customer Information",
    pdfCompanyInfo: "Company Information",
    pdfCustomerName: "customer name",
    pdfPhone: "phone",
    pdfAddress: "address",
    pdfEmail: "email",
    pdfCompanyName: "company name",
    pdfWebsite: "website",
    pdfMaterialCosts: "Material Costs",
    pdfLaborCosts: "Labor Costs",
    pdfImage: "Image",
    pdfMaterialDesc: "Material / Description",
    pdfLaborDesc: "Labor / Description",
    pdfCategory: "Category",
    pdfUnit: "Unit",
    pdfUnitPrice: "Unit Price",
    pdfTotal: "Total",
    pdfMaterialTotal: "Material Total",
    pdfLaborTotal: "Labor Total",
    pdfTermsConditions: "Terms & Conditions",
    pdfBankInfo: "Bank Information",
    pdfPaymentTerms: "Payment Terms",
    pdfAccountHolder: "Account Holder",
    pdfValidityPeriod: "Bid Validity Period",
    pdfBankName: "Bank",
    pdfNotes: "Notes / Other Terms",
    pdfIban: "IBAN",
    pdfSubtotal: "Subtotal",
    pdfKdv: "VAT",
    pdfCommission: "Commission",
    pdfGrandTotal: "Grand Total",
    pdfCompanyLogo: "Company logo",
    
    installApp: "Install App",
    installDescription: "Install NKT Bid for faster access",
    install: "Install",
    notNow: "Not Now",
    
    backOnline: "Internet connection restored",
    offline: "Offline - No internet connection",
    
    language: "Language",
    selectLanguage: "Select Language",

    navHome: "Home",
    searchPlaceholder: "Search proposals, customers or docs…",
    searching: "Searching…",
    noResults: "No results found",
    navProposals: "Bids",
    navTextDocs: "Text Documents",
    navCustomers: "Customers",
    navReports: "Reports",
    appTagline: "Fast, easy, professional",
    userFallback: "User",

    loading: "Loading...",
    print: "Print",
    close: "Close",
    all: "All",
    actions: "Actions",
    dateLabel: "Date",
    statusLabel: "Status",
    amountLabel: "Amount",
    statusApproved: "Approved",
    downloadPdf: "Download PDF",
    sendEmailTitle: "Send Email",
    sendBtn: "Send",
    recipientEmail: "Recipient Email",
    recipientName: "Recipient Name",
    subjectLabel: "Subject",
    messageOptional: "Message (Optional)",
    messagePlaceholder: "Your custom message (a default message is used if left blank)",
    senderLabel: "Sender",
    enterRecipientEmail: "Please enter the recipient email address",
    emailSendFailed: "Email could not be sent",
    deleteFailed: "Delete failed",
    updateFailed: "Update failed",
    pdfGenerating: "Generating PDF...",
    printPreparing: "Preparing to print...",
    printError: "Print error",
    unknownError: "Unknown error",
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

    proposalsSubtitle: "Manage all your bids",
    proposalsLoadFailed: "Bids could not be loaded",
    confirmDeleteProposal: "Are you sure you want to delete this bid?",
    totalAmount: "Total Amount",
    searchProposalPlaceholder: "Search bid or customer...",
    statusFilterLabel: "Status Filter",
    sortLabel: "Sort",
    sortNewest: "Newest",
    sortOldest: "Oldest",
    sortAmountDesc: "Amount (High-Low)",
    sortAmountAsc: "Amount (Low-High)",
    sortTitleAZ: "Title (A-Z)",
    proposalList: "Bid List",
    proposalWord: "bids",
    noProposalsFound: "No bids yet",
    createFirstProposalBtn: "Create First Bid",
    thProposal: "Bid",
    thCustomer: "Customer",
    untitledProposal: "Untitled Bid",
    sendProposal: "Send Bid",
    sendDocument: "Send Document",
    sendByEmailDesc: "will be sent by email",
    subjectProposalPrefix: "Bid",
    subjectDocumentPrefix: "Document",
    ocrCreated: "Created with OCR",

    customersSubtitle: "Manage your customer information",
    newCustomer: "New Customer",
    totalCustomers: "Total Customers",
    searchCustomerPlaceholder: "Search customer (name, email, phone, company)...",
    noSearchResults: "No search results found",
    noCustomersYet: "No customers yet",
    addFirstCustomer: "Add First Customer",
    editCustomer: "Edit Customer",
    addNewCustomer: "Add New Customer",
    customerNameRequired: "Customer name is required",
    customerUpdated: "Customer updated",
    customerAdded: "Customer added",
    customerSaveFailed: "Customer could not be saved",
    customerDeleted: "Customer deleted",
    customerDeleteFailed: "Customer could not be deleted",
    confirmDeleteCustomer: "— are you sure you want to delete this customer?",
    companyLabel: "Company",
    companyOptionalPlaceholder: "Company name (optional)",
    fullNamePlaceholder: "Full Name",
    fullAddressPlaceholder: "Full address",
    customerNotesPlaceholder: "Notes about the customer...",
    taxOffice: "Tax Office",
    taxOfficePlaceholder: "E.g. London",
    taxNumber: "Tax / VAT Number",
    taxNumberPlaceholder: "Tax or VAT registration number",
    tradeTitle: "Trade Title",
    tradeTitlePlaceholder: "Company's full legal name",
    mersisNo: "MERSIS Number",
    mersisNoOptional: "MERSIS Number (optional)",
    mersisNoPlaceholder: "16-digit MERSIS number",
    website: "Company Website",
    websiteOptional: "Company Website (optional)",
    websitePlaceholder: "https://example.com",
    fiscalInfoTitle: "Tax & Business Info",
    senderEmailLabel: "My Reply-To Email",
    senderEmailHelp: "When a proposal recipient hits 'Reply', the message will land at this address. Leave blank to use your account email. Note: proposals are sent from info@nktteklif.com; replies come to you.",
    replyToLabel: "Replies land here",
    ownDomainGuideTitle: "Send from your own domain — Resend guide",
    ownDomainGuideIntro: "By default, proposals are sent from our verified info@nktteklif.com and replies are routed to you. To use your own domain (e.g. proposals@yourcompany.com) as the actual 'From' address, follow these steps:",
    ownDomainStep1: "Go to resend.com and create a free account.",
    ownDomainStep2: "In the left menu click 'Domains' → 'Add Domain' → enter your domain (e.g. yourcompany.com).",
    ownDomainStep3: "Resend shows 3 DNS records (SPF, DKIM, MX). Add these records via your domain provider's DNS panel (GoDaddy, Namecheap, Cloudflare, etc.).",
    ownDomainStep4: "Click 'Verify DNS' in Resend. Propagation may take 5–30 minutes.",
    ownDomainStep5: "Once verification turns green, enter proposals@yourcompany.com in this field — proposals will then be sent from your own domain.",
    ownDomainNote: "Note: personal addresses like Gmail or Yahoo cannot be verified — only domains you own work. If you get stuck, use Resend's DNS Verifier tool.",
    ownDomainOpenResend: "Open Resend",
    mailtoGreeting: "Hello",
    mailtoBodyIntro: "Please find the requested proposal attached.",
    mailtoAttachHint: "(The PDF has been downloaded to your computer — drag and drop it into this email to attach.)",
    mailtoRegards: "Best regards.",
    dataLoadFailed: "Data could not be loaded",
    createNewProposal: "Create New Bid",
    proposalsLabel: "Bids",

    textDocsSubtitle: "Documents scanned with OCR",
    newDocument: "New Document",
    totalDocuments: "Total Documents",
    thisMonth: "This Month",
    quickScan: "Quick Scan",
    scanBtn: "Scan",
    searchDocPlaceholder: "Search document...",
    noDocumentsYet: "No text documents yet",
    createNewDocument: "Create New Document",
    untitledDocument: "Untitled Document",
    documentsLoadFailed: "Documents could not be loaded",
    confirmDeleteDocument: "Are you sure you want to delete this document?",
    documentDeleted: "Document deleted",
    selectImageFile: "Please select an image file",
    fileTooBig: "File too large. Maximum 25MB",
    imageProcessFailed: "Image could not be processed",
    scanningImage: "Scanning image...",
    scanSuccessRedirect: "Scan successful! Redirecting to the editor...",
    scanEmptyResult: "Scan result is empty. Please try a clearer image.",

    textEditorTitle: "Text Editor",
    saveAsText: "Save as Text",
    saveToDb: "Save to database",
    downloadAsPdf: "Download as PDF",
    pdfFormat: "In PDF format",
    sendToPrinter: "Send to printer",
    docInfoTitle: "Document Information",
    docNameLabel: "Document Name",
    docNamePlaceholder: "E.g.: Contract - Villa A",
    enterDocName: "Enter document name...",
    textOnlyNote: "* Saved as text only.",
    customerContactInfo: "Customer and Contact Information",
    selectCustomerLabel: "Select Customer",
    selectCustomerPlaceholder: "Select an existing customer or add new",
    customerNamePlaceholder: "Customer full name",
    customerAddressPlaceholder: "Customer address",
    fontLabel: "Font:",
    boldTitle: "Bold",
    italicTitle: "Italic",
    underlineTitle: "Underline",
    strikeTitle: "Strikethrough",
    alignLeftTitle: "Align Left",
    alignCenterTitle: "Center",
    alignRightTitle: "Align Right",
    newDocBtn: "+ New",
    savedSuffix: "saved",
    docUpdated: "✓ Document updated!",
    docSaved: "✓ Document saved!",
    saveFailed: "Save failed",
    enterAName: "Please enter a name",
    textEmpty: "Text cannot be empty",
    noContentToPrint: "No content to print",
    noContentForPdf: "No content to create PDF",
    printWindowOpened: "Print window opened",
    popupBlocked: "Pop-up blocker is active",
    writeTextHere: "Write your text here...",
    readyForNewDoc: "Ready for a new document",
    docLoadFailed: "Document could not be loaded",
    pdfCreateFailed: "PDF could not be created",

    settingsSubtitle: "Manage your company and account settings",
    settingsInfoBanner: "This information will be displayed in the footer of your PDF and JPG bid exports.",
    companyInfoDesc: "Enter your company details - shown in PDF and JPG footer",
    logoNote: "PNG, JPG - Maximum 2MB",
    websiteLabel: "Website",
    letterheadTitle: "Letterhead",
    letterheadDesc: "Upload your ready letterhead as PNG/JPG. Text is placed between the top and bottom margins you set; side margins are standard 20mm.",
    letterheadImageLabel: "Letterhead Image",
    letterheadNote: "A4 size PNG / JPG (auto-compressed, max 15MB)",
    removeLetterhead: "Remove letterhead",
    topMarginLabel: "Top Margin",
    topMarginDesc: "How far from the top the text should start",
    bottomMarginLabel: "Bottom Margin",
    bottomMarginDesc: "How much space to leave at the bottom",
    letterheadNotUploaded: "No letterhead uploaded",
    textAreaLabel: "Text area",
    textAreaHint: "goes here",
    saveSettingsBtn: "Save Settings",
    profitMarginTitle: "Profit Margin",
    profitMarginDesc: "Automatically added to the price of each material and labor item when creating a bid. It does not appear as a separate line in customer outputs (PDF/JPG). If \"0\", no profit is added.",
    profitMarginRateLabel: "Profit Margin Rate (%)",
    saveProfitMarginBtn: "Save Profit Margin",
    profitMarginExample: "Example: an item worth 1,000 is calculated as {amount} in the bid.",
    noProfitMargin: "No profit margin is currently applied.",
    accountInfoTitle: "Account Information",
    forgetMeBtn: "Forget Me (Shared Computer)",
    forgetMeNote: "\"Forget Me\": Use this if you logged in from someone else's computer — your Google session on that device is also closed and the account will be asked again on next login.",
    forgetMeConfirm: "Forget Me: You will be logged out AND your Google sessions on this device will be closed.\n\nChoose this if you are using a shared computer — account details will be asked again on the next Google login.\n\nContinue?",
    settingsSaved: "Settings saved! They will be used in PDF and JPG exports.",
    settingsSaveFailed: "Settings could not be saved: ",
    logoTooBig: "Logo file must be smaller than 5MB",
    logoPreparing: "Preparing logo...",
    logoProcessFailed: "Logo could not be processed: ",
    imagePreparing: "Preparing image...",
    imageUploaded: "Image uploaded",
    imageTooBig: "Image must be smaller than 15MB",
    imageTooLargeError: "The uploaded image(s) are too large. Please try a smaller letterhead image (max 2-3MB original file).",
    passwordChangedSuccess: "Password changed successfully!",
    passwordChangeError: "Password change error",

    editProposalDesc: "Edit the existing bid",
    newProposalDesc: "Create a new bid",
    readyTemplate: "Templates",
    readyTemplates: "Ready Templates",
    myTemplates: "My Templates",
    saveAsTemplateMenu: "Save This Bid as Template",
    materialsLowerWord: "materials",
    laborLowerWord: "labor",
    downloadingBtn: "Downloading...",
    shareWhatsAppLabel: "WhatsApp",
    shareWhatsAppTitle: "Share PDF via WhatsApp",
    backToHomeTitle: "Back to home",
    projectProposalInfo: "Project and Bid Information",
    projectTitlePlaceholder: "E.g.: Residential Project - Villa A",
    proposalStatusLabel: "Bid Status",
    selectStatusPlaceholder: "Select status",
    callLabel: "Call",
    materialCostTab: "Material Costs",
    laborCostTab: "Labor Costs",
    addImagesTab: "Add Images",
    noMaterialsYet: "No materials added yet",
    noLaborYet: "No labor added yet",
    materialNameLabel: "Material Name",
    roomLabel: "Room / Section (optional)",
    roomPlaceholder: "e.g. Bedroom, Kitchen, Balcony",
    ungroupedRoom: "General",
    inProposalSearchPlaceholder: "Search in this proposal: material, labor or room…",
    materialNamePlaceholder: "E.g.: Ceramic Tiling",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Detailed description",
    imagesMultiLabel: "Images (you can select multiple)",
    materialTotalLabel: "Material Total:",
    laborTotalLabel: "Labor Total:",
    laborNameLabel: "Labor Name",
    laborNamePlaceholder: "E.g.: Ceramic Installation",
    attachmentsTitle: "Images and Attachments",
    attachmentsDesc: "Images, PDF, CAD — any file type can be attached. Images appear in the PDF output with name and info; attached PDFs are appended to the end.",
    uploadingBtn: "Uploading...",
    addAttachmentBtn: "Add Image / File",
    noAttachmentsYet: "No files added yet. Use \"Add Image / File\" to select images, PDFs or CAD files (multiple selection supported).",
    attachmentNameLabel: "Image Name",
    attachmentInfoLabel: "Info / Description",
    attachmentInfoPlaceholder: "E.g.: Front facade view",
    kdvDiscountTitle: "VAT and Discount",
    kdvRateLabel: "VAT Rate (%)",
    kdvAmountLabel: "VAT Amount:",
    discountRateLabel: "Discount Rate (%)",
    discountAmountLabel: "Discount Amount:",
    discountWord: "Discount",
    profitIncludedTemplate: "Profit margin ({pm}%) included in prices",
    invisibleToCustomer: "invisible to customer",
    subtotalColon: "Subtotal:",
    paymentTermsPlaceholder: "E.g.: 50% Upfront, 50% On Delivery",
    validityPlaceholder: "E.g.: 30 days",
    notesOtherTerms: "Notes / Other Terms",
    notesPlaceholder: "Additional notes or terms...",
    accountHolderPlaceholder: "Account holder's name",
    bankNamePlaceholder: "E.g.: National Bank",
    grandTotalCaps: "GRAND TOTAL:",
    tplDialogTitle: "Save as Template",
    tplNameLabel: "Template Name",
    tplNamePlaceholder: "E.g.: Standard Bathroom Renovation",
    tplSaveNote: "The current {m} material and {l} labor items will be saved to the template. You can add them later with one click from the \"Templates\" menu.",
    giveUpBtn: "Cancel",
    enterTitleCustomer: "Please enter a title and customer name",
    proposalUpdated: "Bid updated",
    proposalCreated: "Bid created",
    proposalSaveFailed: "Bid could not be saved",
    proposalLoadFailed: "Bid could not be loaded",
    templateAdded: "\"{name}\" template added — you can edit quantities and prices",
    templateNameRequired: "Please enter a template name",
    noItemsForTemplate: "No items to save to the template",
    templateSaved: "Template saved",
    templateSaveFailed: "Template could not be saved",
    templateDeleted: "Template deleted",
    templateDeleteFailed: "Template could not be deleted",
    imagesUploaded: "{n} images uploaded",
    imageUploadFailed: "Image could not be uploaded",
    imageDeleted: "Image deleted",
    filesAdded: "{n} files added",
    fileUploadFailed: "File could not be uploaded",
    fileRemoved: "File removed",

    reportsTitle: "Reports",
    reportsSubtitle: "Your bid and revenue statistics",
    approvalRate: "Approval Rate",
    approvedRevenue: "Approved Revenue",
    pendingColon: "Pending:",
    estimatedProfit: "Estimated Profit",
    profitVisibilityNote: "From profit margin — visible only to you",
    monthlyChartTitle: "Monthly Bids & Revenue (Last 12 Months)",
    statusDistribution: "Status Distribution",
    topCategoriesTitle: "Most Used Categories",
    noCategoryData: "No category data yet",
    itemsWord: "items",
    topCustomersTitle: "Revenue by Customer (Top 10)",
    noCustomerData: "No customer data yet",
    reportsLoadFailed: "Report data could not be loaded",

    categoryLabel: "Category",
    selectCategoryPlaceholder: "Select category",
    subCategoryLabel: "Subcategory",
    selectSubCategoryPlaceholder: "Select subcategory",
    detailLabel: "Detail / Feature",
    selectDetailPlaceholder: "Select detail",
    measureCalcLabel: "Calculate by Measurement (meters)",
    widthLabel: "Width",
    lengthLabel: "Length",
    heightLabel: "Height",
    heightOptLabel: "Height (opt.)",
    autoTransferred: "Automatically transferred to quantity",
    hideCalcTable: "Hide Calculation Table",
    getPriceBtn: "Get Price",
    gettingPrice: "Getting price...",
    enterItemFirst: "Enter an item name or select a category first",
    aiPriceFailed: "AI price estimate could not be retrieved, please try again",
    noPriceToApply: "No price found to apply",
    priceApplied: "Unit price applied",
    applyMaterialBtn: "Apply Material",
    applyLaborBtn: "Apply Labor",
    avgLabel: "Avg",

    newPasswordTitle: "Set New Password",
    newPasswordDesc: "Create a new password for your account",
    invalidLink: "Invalid Link",
    invalidLinkDesc: "The password reset link is invalid or missing. Please request a new password reset.",
    backToHome: "Back to Home",
    changePasswordBtn: "Change Password",
    passwordResetSuccess: "Your password has been changed successfully!",
    passwordResetFailed: "Password reset failed. The link may be invalid or expired.",

    featureMaterialTitle: "Material Management",
    featureMaterialDesc: "Detailed material lists, unit prices, images and automatic total calculation.",
    featureLaborTitle: "Labor & VAT",
    featureLaborDesc: "Labor costs, VAT calculations and commission management in one platform.",
    featurePdfTitle: "PDF Export",
    featurePdfDesc: "Professional PDF outputs, ready with company logo and customer details.",
    footerDesc: "Professional bid preparation platform. Easily handle material, labor and cost calculations.",
    footerRights: "© 2025 NKT Design. All rights reserved.",
    helpTitle: "Help",
    contactUs: "Contact Us",
    faqLink: "Frequently Asked Questions",
    supportLink: "Support",
    termsLink: "Terms & Conditions",
    servicesTitle: "Services",
    serviceLaborKdv: "Labor & VAT Calculation",
    serviceCost: "Cost Calculation",
    servicePdfJpg: "PDF & JPG Export",
    communityTitle: "Community",
    footerSlogan: "Your Trusted Solution Partner for Design and Decoration Projects",
    resetLinkSentKnown: "A password reset link has been sent to your email address",
    resetLinkSentGeneric: "If the email address is registered, a password reset link has been sent",
    genericError: "An error occurred",
    imageTooBig2MB: "Image must be smaller than 2MB",

    // Settings
    settings: "Settings",
    profileSettings: "Profile Settings",
    profileDescription: "Update your personal information",
    changePassword: "Change Password",
    passwordDescription: "Update your password for account security",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "New Password (Confirm)",
    updatePassword: "Update Password",
    saveChanges: "Save Changes",
    profileUpdated: "Profile updated!",
    passwordChanged: "Password changed!",
    passwordTooShort: "Password must be at least 6 characters!",
    dangerZone: "Danger Zone",
    dangerDescription: "These actions cannot be undone",
    deleteAccount: "Delete Account",
    deleteAccountWarning: "Contact support to delete your account",
    phone: "Phone",
    company: "Company Name",
    address: "Address",

    // Auth & misc extras
    optionalWord: "(optional)",
    loginErrCreds: "Incorrect email or password. If you forgot your password, use the 'Forgot Password' link.",
    loginErrNotFound: "No user is registered with this email address. Please register first using 'Register'.",
    loginErrNetwork: "Could not reach the server. Check your internet connection or try again shortly.",
    loginErrGeneric: "Login failed",
    authSessionNotFound: "Session not found",
    authFailed: "Authentication failed",
    authenticating: "Authenticating...",
    authNotMe: "This is not me — sign in with a different account",
    authNotMeNote: "If \"This is not me\" is selected, the Google session on this device is closed and account details will be asked again on the next login.",
    qtyApplied: "Quantity applied",
    calcEnterHint: "Enter measurements — results will appear automatically",
    pdfOpenedPrintHint: "PDF opened. You can print it from your browser menu.",
    applyBtn: "Apply",
    applyToQuantity: "Apply to Quantity",
    authContinueQuestion: "Do you want to continue with this account?",
    authContinueYes: "Yes, Continue",
    wallAreaFormula: "Wall area = 2×(Width+Length)×Height",
    termsConditions: "Terms and Conditions",
    singleWallFormula: "Single wall = Width×Height",
    floorAreaFormula: "Floor area = Width×Length"
  },
  
  es: {
    professionalSystem: "Sistema Profesional de Pujas",
    forWhomTitle: "¿Para Quién?",
    forWhomDesc: "Una sola plataforma para proyectos de arquitectura, interiorismo y decoración, pujas de reforma y construcción.",
    audArchitects: "Arquitectos",
    audInterior: "Interioristas",
    audDecorators: "Decoradores",
    audContractors: "Empresas de Reforma y Construcción",
    audCraftsmen: "Maestros y Artesanos",
    appTitle: "NKT - Puja",
    appSubtitle: "Creador",
    appDescription: "Programa de pujas para arquitectos, interioristas y decoradores: cree pujas profesionales en PDF en minutos con cálculos de materiales, mano de obra, IVA y descuentos.",
    login: "Iniciar Sesión",
    register: "Registrarse",
    or: "o",
    loginWithGoogle: "Iniciar con Google",
    microCTA: "Crea tu primera propuesta en 60 segundos",
    galleryTitle: "Propuestas de Ejemplo",
    galleryDesc: "Ejemplos reales de propuestas creadas por nuestros usuarios",
    galleryBadge: "PDF Ejemplo",
    galleryProject1: "Reforma de Villa",
    galleryProject2: "Renovación de Oficina",
    galleryProject3: "Instalación de Techo",
    galleryScope1: "Salón · Cocina · Baño",
    galleryScope2: "Suelo · Pintura · Eléctrico",
    galleryScope3: "Panel · Chapa · Canalón",
    galleryMaterial: "Materiales",
    galleryLabor: "Mano de Obra",
    galleryVat: "IVA 21%",
    galleryTotal: "Total General",
    galleryCurrency: "€",
    
    loginTitle: "Iniciar Sesión",
    loginSubtitle: "Accede a tu cuenta",
    email: "Correo Electrónico",
    password: "Contraseña",
    forgotPassword: "Olvidé mi Contraseña",
    loggingIn: "Iniciando sesión...",
    cancel: "Cancelar",
    
    registerTitle: "Registrarse",
    registerSubtitle: "Crear una cuenta nueva",
    fullName: "Nombre Completo",
    passwordConfirm: "Confirmar Contraseña",
    minChars: "Mínimo 6 caracteres",
    registering: "Registrando...",
    profilePicture: "Foto de Perfil",
    maxFileSize: "Máximo 2MB",
    
    forgotPasswordTitle: "Olvidé mi Contraseña",
    forgotPasswordSubtitle: "Enviaremos un enlace de restablecimiento a tu correo",
    sendLink: "Enviar Enlace",
    sending: "Enviando...",
    backToLogin: "Volver al Inicio",
    
    // Dashboard
    panel: "Panel",
    dashboardOverview: "Vista general de sus pujas",
    totalProposals: "Total Pujas",
    approved: "Aprobadas",
    pending: "Pendientes",
    awaitingResponse: "Esperando Respuesta",
    totalRevenue: "Ingresos Totales",
    monthlyProposals: "Pujas Mensuales",
    statusSummary: "Resumen de Estado",
    draft: "Borrador",
    sent: "Enviada",
    rejected: "Rechazada",
    pendingRevenue: "Ingresos Pendientes",
    recentProposals: "Pujas Recientes",
    viewAll: "Ver Todas",
    noProposalsYet: "Aún no hay pujas",
    createFirstProposal: "Cree Su Primera Puja",
    myProposals: "Mis Pujas",
    newProposal: "Nueva Puja",
    noProposals: "Aún no has creado pujas",
    startFirstProposal: "Comienza a crear tu primera puja ahora",
    createProposal: "Crear Puja",
    edit: "Editar",
    delete: "Eliminar",
    material: "Material",
    labor: "Mano de Obra",
    kdv: "IVA",
    commission: "Comisión",
    total: "Total",
    logout: "Cerrar Sesión",
    statusUpdateFailed: "Error al actualizar estado",
    statusUpdated: "Estado actualizado",
    
    // OCR - Image to Text
    scanImage: "Escanear Imagen",
    scanImageDesc: "Convierte pujas escritas a mano a digital con IA",
    uploadImage: "Subir Imagen",
    scanning: "Escaneando...",
    scanComplete: "Escaneo completado",
    scanFailed: "Error en el escaneo",
    extractedText: "Texto Extraído",
    useThisText: "Usar Este Texto",
    textEditor: "Editor de Texto",
    clearText: "Borrar Texto",
    
    editProposal: "Editar Puja",
    newProposalTitle: "Nueva Puja",
    save: "Guardar",
    saving: "Guardando...",
    
    generalInfo: "Información General",
    projectTitle: "Título del Proyecto",
    customerName: "Nombre del Cliente",
    customerPhone: "Teléfono del Cliente",
    customerEmail: "Correo del Cliente",
    customerAddress: "Dirección del Cliente",
    companyName: "Nombre de la Empresa",
    companyLogo: "Logo de la Empresa",
    
    materials: "Materiales",
    laborItems: "Mano de Obra",
    addMaterial: "Agregar Material",
    addLabor: "Agregar Mano de Obra",
    itemName: "Nombre del Artículo",
    quantity: "Cantidad",
    unit: "Unidad",
    unitPrice: "Precio Unitario",
    images: "Imágenes",
    
    summary: "Resumen",
    subtotal: "Subtotal",
    kdvRate: "Tasa de IVA",
    commissionRate: "Tasa de Comisión",
    grandTotal: "Total General",
    
    termsAndConditions: "Términos y Condiciones",
    paymentTerms: "Condiciones de Pago",
    validityPeriod: "Período de Validez",
    notes: "Notas",
    bankInfo: "Información Bancaria",
    accountHolder: "Titular de la Cuenta",
    bankName: "Nombre del Banco",
    iban: "IBAN",
    
    loginSuccess: "¡Inicio de sesión exitoso!",
    loginFailed: "Error al iniciar sesión",
    registerSuccess: "¡Registro exitoso!",
    registerFailed: "Error al registrarse",
    passwordMismatch: "¡Las contraseñas no coinciden!",
    passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
    proposalSaved: "Puja guardada",
    proposalDeleted: "Puja eliminada",
    pdfDownloaded: "PDF descargado",
    jpgDownloaded: "JPG descargado",
    downloadFailed: "Error en la descarga",
    
    // PDF Export Labels
    pdfCustomerInfo: "Información del Cliente",
    pdfCompanyInfo: "Información de la Empresa",
    pdfCustomerName: "nombre del cliente",
    pdfPhone: "teléfono",
    pdfAddress: "dirección",
    pdfEmail: "correo",
    pdfCompanyName: "nombre de empresa",
    pdfWebsite: "sitio web",
    pdfMaterialCosts: "Costos de Materiales",
    pdfLaborCosts: "Costos de Mano de Obra",
    pdfImage: "Imagen",
    pdfMaterialDesc: "Material / Descripción",
    pdfLaborDesc: "Mano de Obra / Descripción",
    pdfCategory: "Categoría",
    pdfUnit: "Unidad",
    pdfUnitPrice: "Precio Unitario",
    pdfTotal: "Total",
    pdfMaterialTotal: "Total Materiales",
    pdfLaborTotal: "Total Mano de Obra",
    pdfTermsConditions: "Términos y Condiciones",
    pdfBankInfo: "Información Bancaria",
    pdfPaymentTerms: "Condiciones de Pago",
    pdfAccountHolder: "Titular de Cuenta",
    pdfValidityPeriod: "Período de Validez",
    pdfBankName: "Banco",
    pdfNotes: "Notas / Otros Términos",
    pdfIban: "IBAN",
    pdfSubtotal: "Subtotal",
    pdfKdv: "IVA",
    pdfCommission: "Comisión",
    pdfGrandTotal: "Total General",
    pdfCompanyLogo: "Logo de empresa",
    
    installApp: "Instalar Aplicación",
    installDescription: "Instala NKT Puja para acceso más rápido",
    install: "Instalar",
    notNow: "Ahora No",
    
    backOnline: "Conexión a internet restaurada",
    offline: "Sin conexión - No hay internet",
    
    language: "Idioma",
    selectLanguage: "Seleccionar Idioma",

    navHome: "Inicio",
    searchPlaceholder: "Buscar propuestas, clientes o docs…",
    searching: "Buscando…",
    noResults: "Sin resultados",
    navProposals: "Pujas",
    navTextDocs: "Documentos de Texto",
    navCustomers: "Clientes",
    navReports: "Informes",
    appTagline: "Rápido, fácil, profesional",
    userFallback: "Usuario",

    loading: "Cargando...",
    print: "Imprimir",
    close: "Cerrar",
    all: "Todos",
    actions: "Acciones",
    dateLabel: "Fecha",
    statusLabel: "Estado",
    amountLabel: "Importe",
    statusApproved: "Aprobada",
    downloadPdf: "Descargar PDF",
    sendEmailTitle: "Enviar Correo",
    sendBtn: "Enviar",
    recipientEmail: "Correo del Destinatario",
    recipientName: "Nombre del Destinatario",
    subjectLabel: "Asunto",
    messageOptional: "Mensaje (Opcional)",
    messagePlaceholder: "Su mensaje personalizado (si lo deja vacío se usa un mensaje predeterminado)",
    senderLabel: "Remitente",
    enterRecipientEmail: "Por favor ingrese el correo del destinatario",
    emailSendFailed: "No se pudo enviar el correo",
    deleteFailed: "Error al eliminar",
    updateFailed: "Error al actualizar",
    pdfGenerating: "Generando PDF...",
    printPreparing: "Preparando impresión...",
    printError: "Error de impresión",
    unknownError: "Error desconocido",
    monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],

    proposalsSubtitle: "Gestione todas sus pujas",
    proposalsLoadFailed: "No se pudieron cargar las pujas",
    confirmDeleteProposal: "¿Está seguro de que desea eliminar esta puja?",
    totalAmount: "Importe Total",
    searchProposalPlaceholder: "Buscar puja o cliente...",
    statusFilterLabel: "Filtro de Estado",
    sortLabel: "Ordenar",
    sortNewest: "Más Reciente",
    sortOldest: "Más Antiguo",
    sortAmountDesc: "Importe (Mayor-Menor)",
    sortAmountAsc: "Importe (Menor-Mayor)",
    sortTitleAZ: "Título (A-Z)",
    proposalList: "Lista de Pujas",
    proposalWord: "pujas",
    noProposalsFound: "Aún no hay pujas",
    createFirstProposalBtn: "Crear Primera Puja",
    thProposal: "Puja",
    thCustomer: "Cliente",
    untitledProposal: "Puja sin Título",
    sendProposal: "Enviar Puja",
    sendDocument: "Enviar Documento",
    sendByEmailDesc: "se enviará por correo electrónico",
    subjectProposalPrefix: "Puja",
    subjectDocumentPrefix: "Documento",
    ocrCreated: "Creado con OCR",

    customersSubtitle: "Gestione la información de sus clientes",
    newCustomer: "Nuevo Cliente",
    totalCustomers: "Total Clientes",
    searchCustomerPlaceholder: "Buscar cliente (nombre, correo, teléfono, empresa)...",
    noSearchResults: "No se encontraron resultados",
    noCustomersYet: "Aún no hay clientes",
    addFirstCustomer: "Agregar Primer Cliente",
    editCustomer: "Editar Cliente",
    addNewCustomer: "Agregar Nuevo Cliente",
    customerNameRequired: "El nombre del cliente es obligatorio",
    customerUpdated: "Cliente actualizado",
    customerAdded: "Cliente agregado",
    customerSaveFailed: "No se pudo guardar el cliente",
    customerDeleted: "Cliente eliminado",
    customerDeleteFailed: "No se pudo eliminar el cliente",
    confirmDeleteCustomer: "— ¿está seguro de que desea eliminar este cliente?",
    companyLabel: "Empresa",
    companyOptionalPlaceholder: "Nombre de la empresa (opcional)",
    fullNamePlaceholder: "Nombre Completo",
    fullAddressPlaceholder: "Dirección completa",
    customerNotesPlaceholder: "Notas sobre el cliente...",
    taxOffice: "Oficina de Impuestos",
    taxOfficePlaceholder: "Ej: Madrid",
    taxNumber: "Número Fiscal / NIF",
    taxNumberPlaceholder: "Número de identificación fiscal",
    tradeTitle: "Razón Social",
    tradeTitlePlaceholder: "Nombre legal completo de la empresa",
    mersisNo: "Número MERSIS",
    mersisNoOptional: "Número MERSIS (opcional)",
    mersisNoPlaceholder: "Número MERSIS de 16 dígitos",
    website: "Sitio Web de la Empresa",
    websiteOptional: "Sitio Web de la Empresa (opcional)",
    websitePlaceholder: "https://ejemplo.com",
    fiscalInfoTitle: "Información Fiscal y Comercial",
    senderEmailLabel: "Mi correo de Respuesta (Reply-To)",
    senderEmailHelp: "Cuando el destinatario pulse 'Responder', el mensaje llegará a esta dirección. Déjelo en blanco para usar el correo de su cuenta. Nota: las propuestas se envían desde info@nktteklif.com; las respuestas llegan a usted.",
    replyToLabel: "Las respuestas llegan aquí",
    ownDomainGuideTitle: "Envía desde tu propio dominio — Guía Resend",
    ownDomainGuideIntro: "Por defecto, las propuestas se envían desde nuestro info@nktteklif.com verificado y las respuestas llegan a usted. Para usar su propio dominio (ej. propuestas@suempresa.com) como remitente real, siga estos pasos:",
    ownDomainStep1: "Vaya a resend.com y cree una cuenta gratuita.",
    ownDomainStep2: "En el menú izquierdo pulse 'Domains' → 'Add Domain' → ingrese su dominio (ej. suempresa.com).",
    ownDomainStep3: "Resend le mostrará 3 registros DNS (SPF, DKIM, MX). Agréguelos en el panel DNS de su proveedor (GoDaddy, Namecheap, Cloudflare, etc.).",
    ownDomainStep4: "Haga clic en 'Verify DNS' en Resend. La propagación puede tardar 5–30 minutos.",
    ownDomainStep5: "Cuando la verificación pase a verde, escriba propuestas@suempresa.com en este campo — las propuestas saldrán desde su dominio.",
    ownDomainNote: "Nota: las direcciones personales como Gmail o Yahoo no se pueden verificar — solo funcionan los dominios que usted posee.",
    ownDomainOpenResend: "Abrir Resend",
    mailtoGreeting: "Hola",
    mailtoBodyIntro: "Adjunto la propuesta solicitada.",
    mailtoAttachHint: "(El PDF se ha descargado a su ordenador — arrástrelo y suéltelo en este correo para adjuntarlo.)",
    mailtoRegards: "Un cordial saludo.",
    dataLoadFailed: "No se pudieron cargar los datos",
    createNewProposal: "Crear Nueva Puja",
    proposalsLabel: "Pujas",

    textDocsSubtitle: "Documentos escaneados con OCR",
    newDocument: "Nuevo Documento",
    totalDocuments: "Total Documentos",
    thisMonth: "Este Mes",
    quickScan: "Escaneo Rápido",
    scanBtn: "Escanear",
    searchDocPlaceholder: "Buscar documento...",
    noDocumentsYet: "Aún no hay documentos de texto",
    createNewDocument: "Crear Nuevo Documento",
    untitledDocument: "Documento sin Título",
    documentsLoadFailed: "No se pudieron cargar los documentos",
    confirmDeleteDocument: "¿Está seguro de que desea eliminar este documento?",
    documentDeleted: "Documento eliminado",
    selectImageFile: "Por favor seleccione un archivo de imagen",
    fileTooBig: "Archivo demasiado grande. Máximo 25MB",
    imageProcessFailed: "No se pudo procesar la imagen",
    scanningImage: "Escaneando imagen...",
    scanSuccessRedirect: "¡Escaneo exitoso! Redirigiendo al editor...",
    scanEmptyResult: "El resultado del escaneo está vacío. Pruebe con una imagen más nítida.",

    textEditorTitle: "Editor de Texto",
    saveAsText: "Guardar como Texto",
    saveToDb: "Guardar en la base de datos",
    downloadAsPdf: "Descargar como PDF",
    pdfFormat: "En formato PDF",
    sendToPrinter: "Enviar a la impresora",
    docInfoTitle: "Información del Documento",
    docNameLabel: "Nombre del Documento",
    docNamePlaceholder: "Ej: Contrato - Villa A",
    enterDocName: "Ingrese el nombre del documento...",
    textOnlyNote: "* Se guarda solo como texto.",
    customerContactInfo: "Información del Cliente y Contacto",
    selectCustomerLabel: "Seleccionar Cliente",
    selectCustomerPlaceholder: "Seleccione un cliente existente o agregue uno nuevo",
    customerNamePlaceholder: "Nombre completo del cliente",
    customerAddressPlaceholder: "Dirección del cliente",
    fontLabel: "Fuente:",
    boldTitle: "Negrita",
    italicTitle: "Cursiva",
    underlineTitle: "Subrayado",
    strikeTitle: "Tachado",
    alignLeftTitle: "Alinear a la Izquierda",
    alignCenterTitle: "Centrar",
    alignRightTitle: "Alinear a la Derecha",
    newDocBtn: "+ Nuevo",
    savedSuffix: "guardado",
    docUpdated: "✓ ¡Documento actualizado!",
    docSaved: "✓ ¡Documento guardado!",
    saveFailed: "Error al guardar",
    enterAName: "Por favor ingrese un nombre",
    textEmpty: "El texto no puede estar vacío",
    noContentToPrint: "No hay contenido para imprimir",
    noContentForPdf: "No hay contenido para crear el PDF",
    printWindowOpened: "Ventana de impresión abierta",
    popupBlocked: "El bloqueador de ventanas emergentes está activo",
    writeTextHere: "Escriba su texto aquí...",
    readyForNewDoc: "Listo para un nuevo documento",
    docLoadFailed: "No se pudo cargar el documento",
    pdfCreateFailed: "No se pudo crear el PDF",

    settingsSubtitle: "Gestione la configuración de su empresa y cuenta",
    settingsInfoBanner: "Esta información se mostrará en el pie de página de sus exportaciones PDF y JPG.",
    companyInfoDesc: "Ingrese los datos de su empresa - se mostrarán en el pie de PDF y JPG",
    logoNote: "PNG, JPG - Máximo 2MB",
    websiteLabel: "Sitio Web",
    letterheadTitle: "Papel Membretado",
    letterheadDesc: "Suba su papel membretado en PNG/JPG. El texto se coloca entre los márgenes superior e inferior que establezca; los márgenes laterales son de 20mm estándar.",
    letterheadImageLabel: "Imagen del Membrete",
    letterheadNote: "PNG / JPG tamaño A4 (compresión automática, máx 15MB)",
    removeLetterhead: "Quitar membrete",
    topMarginLabel: "Margen Superior",
    topMarginDesc: "A qué distancia del borde superior debe comenzar el texto",
    bottomMarginLabel: "Margen Inferior",
    bottomMarginDesc: "Cuánto espacio dejar en la parte inferior",
    letterheadNotUploaded: "No se ha subido membrete",
    textAreaLabel: "Área de texto",
    textAreaHint: "va aquí",
    saveSettingsBtn: "Guardar Configuración",
    profitMarginTitle: "Margen de Ganancia",
    profitMarginDesc: "Se agrega automáticamente al precio de cada material y mano de obra al crear una puja. No aparece como línea separada en las salidas del cliente (PDF/JPG). Si es \"0\", no se agrega ganancia.",
    profitMarginRateLabel: "Tasa de Margen de Ganancia (%)",
    saveProfitMarginBtn: "Guardar Margen de Ganancia",
    profitMarginExample: "Ejemplo: un artículo de 1.000 se calcula como {amount} en la puja.",
    noProfitMargin: "Actualmente no se aplica margen de ganancia.",
    accountInfoTitle: "Información de la Cuenta",
    forgetMeBtn: "Olvidarme (Computadora Compartida)",
    forgetMeNote: "\"Olvidarme\": Use esto si inició sesión desde la computadora de otra persona — su sesión de Google en ese dispositivo también se cerrará y se pedirá la cuenta nuevamente en el próximo inicio.",
    forgetMeConfirm: "Olvidarme: Se cerrará su sesión Y sus sesiones de Google en este dispositivo.\n\nElija esto si usa una computadora compartida — los datos de la cuenta se pedirán nuevamente en el próximo inicio con Google.\n\n¿Continuar?",
    settingsSaved: "¡Configuración guardada! Se usará en las exportaciones PDF y JPG.",
    settingsSaveFailed: "No se pudo guardar la configuración: ",
    logoTooBig: "El archivo del logo debe ser menor de 5MB",
    logoPreparing: "Preparando logo...",
    logoProcessFailed: "No se pudo procesar el logo: ",
    imagePreparing: "Preparando imagen...",
    imageUploaded: "Imagen subida",
    imageTooBig: "La imagen debe ser menor de 15MB",
    imageTooLargeError: "La(s) imagen(es) subida(s) son demasiado grandes. Pruebe con una imagen de membrete más pequeña (máx 2-3MB archivo original).",
    passwordChangedSuccess: "¡Contraseña cambiada exitosamente!",
    passwordChangeError: "Error al cambiar la contraseña",

    editProposalDesc: "Edite la puja existente",
    newProposalDesc: "Cree una nueva puja",
    readyTemplate: "Plantillas",
    readyTemplates: "Plantillas Listas",
    myTemplates: "Mis Plantillas",
    saveAsTemplateMenu: "Guardar Esta Puja como Plantilla",
    materialsLowerWord: "materiales",
    laborLowerWord: "mano de obra",
    downloadingBtn: "Descargando...",
    shareWhatsAppLabel: "WhatsApp",
    shareWhatsAppTitle: "Compartir PDF por WhatsApp",
    backToHomeTitle: "Volver al inicio",
    projectProposalInfo: "Información del Proyecto y Puja",
    projectTitlePlaceholder: "Ej: Proyecto Residencial - Villa A",
    proposalStatusLabel: "Estado de la Puja",
    selectStatusPlaceholder: "Seleccione el estado",
    callLabel: "Llamar",
    materialCostTab: "Costos de Materiales",
    laborCostTab: "Costos de Mano de Obra",
    addImagesTab: "Agregar Imágenes",
    noMaterialsYet: "Aún no se han agregado materiales",
    noLaborYet: "Aún no se ha agregado mano de obra",
    materialNameLabel: "Nombre del Material",
    roomLabel: "Habitación / Sección (opcional)",
    roomPlaceholder: "Ej: Dormitorio, Cocina, Balcón",
    ungroupedRoom: "General",
    inProposalSearchPlaceholder: "Buscar en esta propuesta: material, mano de obra, sala…",
    materialNamePlaceholder: "Ej: Revestimiento Cerámico",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Descripción detallada",
    imagesMultiLabel: "Imágenes (puede seleccionar varias)",
    materialTotalLabel: "Total Materiales:",
    laborTotalLabel: "Total Mano de Obra:",
    laborNameLabel: "Nombre de la Mano de Obra",
    laborNamePlaceholder: "Ej: Instalación de Cerámica",
    attachmentsTitle: "Imágenes y Adjuntos",
    attachmentsDesc: "Imágenes, PDF, CAD — se puede adjuntar cualquier tipo de archivo. Las imágenes aparecen en el PDF con nombre e info; los PDFs adjuntos se añaden al final.",
    uploadingBtn: "Subiendo...",
    addAttachmentBtn: "Agregar Imagen / Archivo",
    noAttachmentsYet: "Aún no se han agregado archivos. Use \"Agregar Imagen / Archivo\" para seleccionar imágenes, PDFs o archivos CAD (selección múltiple admitida).",
    attachmentNameLabel: "Nombre de la Imagen",
    attachmentInfoLabel: "Info / Descripción",
    attachmentInfoPlaceholder: "Ej: Vista de fachada frontal",
    kdvDiscountTitle: "IVA y Descuento",
    kdvRateLabel: "Tasa de IVA (%)",
    kdvAmountLabel: "Importe de IVA:",
    discountRateLabel: "Tasa de Descuento (%)",
    discountAmountLabel: "Importe del Descuento:",
    discountWord: "Descuento",
    profitIncludedTemplate: "Margen de ganancia ({pm}%) incluido en los precios",
    invisibleToCustomer: "invisible para el cliente",
    subtotalColon: "Subtotal:",
    paymentTermsPlaceholder: "Ej: 50% Anticipo, 50% Contra Entrega",
    validityPlaceholder: "Ej: 30 días",
    notesOtherTerms: "Notas / Otros Términos",
    notesPlaceholder: "Notas o términos adicionales...",
    accountHolderPlaceholder: "Nombre del titular de la cuenta",
    bankNamePlaceholder: "Ej: Banco Nacional",
    grandTotalCaps: "TOTAL GENERAL:",
    tplDialogTitle: "Guardar como Plantilla",
    tplNameLabel: "Nombre de la Plantilla",
    tplNamePlaceholder: "Ej: Renovación Estándar de Baño",
    tplSaveNote: "Los {m} materiales y {l} elementos de mano de obra actuales se guardarán en la plantilla. Luego podrá agregarlos con un clic desde el menú \"Plantillas\".",
    giveUpBtn: "Cancelar",
    enterTitleCustomer: "Por favor ingrese un título y el nombre del cliente",
    proposalUpdated: "Puja actualizada",
    proposalCreated: "Puja creada",
    proposalSaveFailed: "No se pudo guardar la puja",
    proposalLoadFailed: "No se pudo cargar la puja",
    templateAdded: "Plantilla \"{name}\" agregada — puede editar cantidades y precios",
    templateNameRequired: "Por favor ingrese un nombre de plantilla",
    noItemsForTemplate: "No hay elementos para guardar en la plantilla",
    templateSaved: "Plantilla guardada",
    templateSaveFailed: "No se pudo guardar la plantilla",
    templateDeleted: "Plantilla eliminada",
    templateDeleteFailed: "No se pudo eliminar la plantilla",
    imagesUploaded: "{n} imágenes subidas",
    imageUploadFailed: "No se pudo subir la imagen",
    imageDeleted: "Imagen eliminada",
    filesAdded: "{n} archivos agregados",
    fileUploadFailed: "No se pudo subir el archivo",
    fileRemoved: "Archivo eliminado",

    reportsTitle: "Informes",
    reportsSubtitle: "Estadísticas de sus pujas e ingresos",
    approvalRate: "Tasa de Aprobación",
    approvedRevenue: "Ingresos Aprobados",
    pendingColon: "Pendiente:",
    estimatedProfit: "Ganancia Estimada",
    profitVisibilityNote: "Del margen de ganancia — visible solo para usted",
    monthlyChartTitle: "Pujas e Ingresos Mensuales (Últimos 12 Meses)",
    statusDistribution: "Distribución de Estados",
    topCategoriesTitle: "Categorías Más Usadas",
    noCategoryData: "Aún no hay datos de categorías",
    itemsWord: "elementos",
    topCustomersTitle: "Ingresos por Cliente (Top 10)",
    noCustomerData: "Aún no hay datos de clientes",
    reportsLoadFailed: "No se pudieron cargar los datos del informe",

    categoryLabel: "Categoría",
    selectCategoryPlaceholder: "Seleccione categoría",
    subCategoryLabel: "Subcategoría",
    selectSubCategoryPlaceholder: "Seleccione subcategoría",
    detailLabel: "Detalle / Característica",
    selectDetailPlaceholder: "Seleccione detalle",
    measureCalcLabel: "Calcular por Medida (metros)",
    widthLabel: "Ancho",
    lengthLabel: "Largo",
    heightLabel: "Altura",
    heightOptLabel: "Altura (opc.)",
    autoTransferred: "Transferido automáticamente a la cantidad",
    hideCalcTable: "Ocultar Tabla de Cálculo",
    getPriceBtn: "Obtener Precio",
    gettingPrice: "Obteniendo precio...",
    enterItemFirst: "Primero ingrese un nombre de elemento o seleccione una categoría",
    aiPriceFailed: "No se pudo obtener la estimación de precio de IA, intente nuevamente",
    noPriceToApply: "No se encontró precio para aplicar",
    priceApplied: "Precio unitario aplicado",
    applyMaterialBtn: "Aplicar Material",
    applyLaborBtn: "Aplicar Mano de Obra",
    avgLabel: "Prom",

    newPasswordTitle: "Establecer Nueva Contraseña",
    newPasswordDesc: "Cree una nueva contraseña para su cuenta",
    invalidLink: "Enlace Inválido",
    invalidLinkDesc: "El enlace de restablecimiento es inválido o falta. Solicite un nuevo restablecimiento de contraseña.",
    backToHome: "Volver al Inicio",
    changePasswordBtn: "Cambiar Contraseña",
    passwordResetSuccess: "¡Su contraseña ha sido cambiada exitosamente!",
    passwordResetFailed: "Error al restablecer la contraseña. El enlace puede ser inválido o haber expirado.",

    featureMaterialTitle: "Gestión de Materiales",
    featureMaterialDesc: "Listas detalladas de materiales, precios unitarios, imágenes y cálculo automático de totales.",
    featureLaborTitle: "Mano de Obra e IVA",
    featureLaborDesc: "Costos de mano de obra, cálculos de IVA y gestión de comisiones en una sola plataforma.",
    featurePdfTitle: "Exportación PDF",
    featurePdfDesc: "Salidas PDF profesionales, listas con logo de empresa y datos del cliente.",
    footerDesc: "Plataforma profesional de preparación de pujas. Realice fácilmente cálculos de materiales, mano de obra y costos.",
    footerRights: "© 2025 NKT Diseño. Todos los derechos reservados.",
    helpTitle: "Ayuda",
    contactUs: "Contáctenos",
    faqLink: "Preguntas Frecuentes",
    supportLink: "Soporte",
    termsLink: "Términos y Condiciones",
    servicesTitle: "Servicios",
    serviceLaborKdv: "Cálculo de Mano de Obra e IVA",
    serviceCost: "Cálculo de Costos",
    servicePdfJpg: "Exportación PDF y JPG",
    communityTitle: "Comunidad",
    footerSlogan: "Su Socio de Confianza para Proyectos de Diseño y Decoración",
    resetLinkSentKnown: "Se ha enviado un enlace de restablecimiento a su correo electrónico",
    resetLinkSentGeneric: "Si el correo está registrado, se ha enviado un enlace de restablecimiento",
    genericError: "Ocurrió un error",
    imageTooBig2MB: "La imagen debe ser menor de 2MB",

    // Settings
    settings: "Ajustes",
    profileSettings: "Ajustes de Perfil",
    profileDescription: "Actualice su información personal",
    changePassword: "Cambiar Contraseña",
    passwordDescription: "Actualice su contraseña para la seguridad de su cuenta",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmNewPassword: "Nueva Contraseña (Confirmar)",
    updatePassword: "Actualizar Contraseña",
    saveChanges: "Guardar Cambios",
    profileUpdated: "¡Perfil actualizado!",
    passwordChanged: "¡Contraseña cambiada!",
    passwordTooShort: "¡La contraseña debe tener al menos 6 caracteres!",
    dangerZone: "Zona Peligrosa",
    dangerDescription: "Estas acciones no se pueden deshacer",
    deleteAccount: "Eliminar Cuenta",
    deleteAccountWarning: "Contacte con soporte para eliminar su cuenta",
    phone: "Teléfono",
    company: "Nombre de la Empresa",
    address: "Dirección",

    // Auth & misc extras
    optionalWord: "(opcional)",
    loginErrCreds: "Correo o contraseña incorrectos. Si olvidó su contraseña, use el enlace 'Olvidé mi Contraseña'.",
    loginErrNotFound: "No hay ningún usuario registrado con este correo. Regístrese primero usando 'Registrarse'.",
    loginErrNetwork: "No se pudo conectar al servidor. Verifique su conexión a internet o intente de nuevo en breve.",
    loginErrGeneric: "No se pudo iniciar sesión",
    authSessionNotFound: "Sesión no encontrada",
    authFailed: "Error de autenticación",
    authenticating: "Autenticando...",
    authNotMe: "No soy yo — iniciar con otra cuenta",
    authNotMeNote: "Si selecciona \"No soy yo\", la sesión de Google en este dispositivo se cerrará y se pedirán los datos de la cuenta en el próximo inicio de sesión.",
    qtyApplied: "Cantidad aplicada",
    calcEnterHint: "Ingrese las medidas — los resultados aparecerán automáticamente",
    pdfOpenedPrintHint: "PDF abierto. Puede imprimirlo desde el menú del navegador.",
    applyBtn: "Aplicar",
    applyToQuantity: "Aplicar a Cantidad",
    authContinueQuestion: "¿Desea continuar con esta cuenta?",
    authContinueYes: "Sí, Continuar",
    wallAreaFormula: "Área de pared = 2×(Ancho+Largo)×Alto",
    termsConditions: "Términos y Condiciones",
    singleWallFormula: "Pared única = Ancho×Alto",
    floorAreaFormula: "Área de piso = Ancho×Largo"
  },
  
  ar: {
    professionalSystem: "نظام عروض الأسعار الاحترافي",
    forWhomTitle: "لمن هذا البرنامج؟",
    forWhomDesc: "منصة واحدة للمشاريع المعمارية وأعمال التصميم الداخلي والديكور وعروض الترميم والبناء.",
    audArchitects: "المهندسون المعماريون",
    audInterior: "مصممو الديكور الداخلي",
    audDecorators: "الديكوريون",
    audContractors: "شركات الترميم والبناء",
    audCraftsmen: "الحرفيون والمعلمون",
    appTitle: "NKT - عرض السعر",
    appSubtitle: "منشئ",
    appDescription: "برنامج عروض أسعار للمهندسين المعماريين ومصممي الديكور الداخلي والديكور: أنشئ عروض أسعار PDF احترافية في دقائق مع حسابات المواد والعمالة والضريبة والخصم.",
    login: "تسجيل الدخول",
    register: "تسجيل",
    or: "أو",
    loginWithGoogle: "الدخول بواسطة جوجل",
    microCTA: "أنشئ أول عرض سعر في 60 ثانية",
    galleryTitle: "عروض نموذجية",
    galleryDesc: "أمثلة حقيقية على عروض أعدها مستخدمونا",
    galleryBadge: "نموذج PDF",
    galleryProject1: "ترميم فيلا",
    galleryProject2: "تجديد مكتب",
    galleryProject3: "تركيب سقف",
    galleryScope1: "صالة · مطبخ · حمام",
    galleryScope2: "أرضية · دهان · كهرباء",
    galleryScope3: "لوح · صفيح · ميزاب",
    galleryMaterial: "المواد",
    galleryLabor: "العمالة",
    galleryVat: "ضريبة 15%",
    galleryTotal: "المجموع الكلي",
    galleryCurrency: "﷼",
    
    loginTitle: "تسجيل الدخول",
    loginSubtitle: "سجل الدخول إلى حسابك",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور",
    loggingIn: "جاري تسجيل الدخول...",
    cancel: "إلغاء",
    
    registerTitle: "تسجيل",
    registerSubtitle: "إنشاء حساب جديد",
    fullName: "الاسم الكامل",
    passwordConfirm: "تأكيد كلمة المرور",
    minChars: "6 أحرف على الأقل",
    registering: "جاري التسجيل...",
    profilePicture: "صورة الملف الشخصي",
    maxFileSize: "الحد الأقصى 2 ميجابايت",
    
    forgotPasswordTitle: "نسيت كلمة المرور",
    forgotPasswordSubtitle: "سنرسل رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
    sendLink: "إرسال الرابط",
    sending: "جاري الإرسال...",
    backToLogin: "العودة لتسجيل الدخول",
    
    // Dashboard
    panel: "لوحة التحكم",
    dashboardOverview: "نظرة عامة على عروض الأسعار الخاصة بك",
    totalProposals: "إجمالي العروض",
    approved: "الموافق عليها",
    pending: "قيد الانتظار",
    awaitingResponse: "في انتظار الرد",
    totalRevenue: "إجمالي الإيرادات",
    monthlyProposals: "العروض الشهرية",
    statusSummary: "ملخص الحالة",
    draft: "مسودة",
    sent: "مرسلة",
    rejected: "مرفوضة",
    pendingRevenue: "الإيرادات المعلقة",
    recentProposals: "العروض الأخيرة",
    viewAll: "عرض الكل",
    noProposalsYet: "لا توجد عروض بعد",
    createFirstProposal: "أنشئ عرضك الأول",
    myProposals: "عروض الأسعار الخاصة بي",
    newProposal: "عرض سعر جديد",
    noProposals: "لم تقم بإنشاء أي عروض أسعار بعد",
    startFirstProposal: "ابدأ بإنشاء عرض السعر الأول الآن",
    createProposal: "إنشاء عرض سعر",
    edit: "تعديل",
    delete: "حذف",
    material: "المواد",
    labor: "العمالة",
    kdv: "ضريبة القيمة المضافة",
    commission: "العمولة",
    total: "المجموع",
    logout: "تسجيل الخروج",
    statusUpdateFailed: "فشل تحديث الحالة",
    statusUpdated: "تم تحديث الحالة",
    
    // OCR - Image to Text
    scanImage: "مسح الصورة",
    scanImageDesc: "حوّل عروض الأسعار المكتوبة بخط اليد إلى رقمية باستخدام الذكاء الاصطناعي",
    uploadImage: "رفع الصورة",
    scanning: "جاري المسح...",
    scanComplete: "اكتمل المسح",
    scanFailed: "فشل المسح",
    extractedText: "النص المستخرج",
    useThisText: "استخدم هذا النص",
    textEditor: "محرر النص",
    clearText: "مسح النص",
    
    editProposal: "تعديل عرض السعر",
    newProposalTitle: "عرض سعر جديد",
    save: "حفظ",
    saving: "جاري الحفظ...",
    
    generalInfo: "معلومات عامة",
    projectTitle: "عنوان المشروع",
    customerName: "اسم العميل",
    customerPhone: "هاتف العميل",
    customerEmail: "بريد العميل",
    customerAddress: "عنوان العميل",
    companyName: "اسم الشركة",
    companyLogo: "شعار الشركة",
    
    materials: "المواد",
    laborItems: "العمالة",
    addMaterial: "إضافة مادة",
    addLabor: "إضافة عمالة",
    itemName: "اسم العنصر",
    quantity: "الكمية",
    unit: "الوحدة",
    unitPrice: "سعر الوحدة",
    images: "الصور",
    
    summary: "الملخص",
    subtotal: "المجموع الفرعي",
    kdvRate: "نسبة ضريبة القيمة المضافة",
    commissionRate: "نسبة العمولة",
    grandTotal: "المجموع الكلي",
    
    termsAndConditions: "الشروط والأحكام",
    paymentTerms: "شروط الدفع",
    validityPeriod: "فترة الصلاحية",
    notes: "ملاحظات",
    bankInfo: "معلومات البنك",
    accountHolder: "صاحب الحساب",
    bankName: "اسم البنك",
    iban: "IBAN",
    
    loginSuccess: "تم تسجيل الدخول بنجاح!",
    loginFailed: "فشل تسجيل الدخول",
    registerSuccess: "تم التسجيل بنجاح!",
    registerFailed: "فشل التسجيل",
    passwordMismatch: "كلمات المرور غير متطابقة!",
    passwordMinLength: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    proposalSaved: "تم حفظ عرض السعر",
    proposalDeleted: "تم حذف عرض السعر",
    pdfDownloaded: "تم تنزيل PDF",
    jpgDownloaded: "تم تنزيل JPG",
    downloadFailed: "فشل التنزيل",
    
    // PDF Export Labels
    pdfCustomerInfo: "معلومات العميل",
    pdfCompanyInfo: "معلومات الشركة",
    pdfCustomerName: "اسم العميل",
    pdfPhone: "الهاتف",
    pdfAddress: "العنوان",
    pdfEmail: "البريد الإلكتروني",
    pdfCompanyName: "اسم الشركة",
    pdfWebsite: "الموقع الإلكتروني",
    pdfMaterialCosts: "تكاليف المواد",
    pdfLaborCosts: "تكاليف العمالة",
    pdfImage: "الصورة",
    pdfMaterialDesc: "المادة / الوصف",
    pdfLaborDesc: "العمالة / الوصف",
    pdfCategory: "الفئة",
    pdfUnit: "الوحدة",
    pdfUnitPrice: "سعر الوحدة",
    pdfTotal: "المجموع",
    pdfMaterialTotal: "إجمالي المواد",
    pdfLaborTotal: "إجمالي العمالة",
    pdfTermsConditions: "الشروط والأحكام",
    pdfBankInfo: "المعلومات المصرفية",
    pdfPaymentTerms: "شروط الدفع",
    pdfAccountHolder: "صاحب الحساب",
    pdfValidityPeriod: "فترة صلاحية العرض",
    pdfBankName: "البنك",
    pdfNotes: "ملاحظات / شروط أخرى",
    pdfIban: "IBAN",
    pdfSubtotal: "المجموع الفرعي",
    pdfKdv: "ضريبة القيمة المضافة",
    pdfCommission: "العمولة",
    pdfGrandTotal: "المجموع الكلي",
    pdfCompanyLogo: "شعار الشركة",
    
    installApp: "تثبيت التطبيق",
    installDescription: "قم بتثبيت NKT للوصول بشكل أسرع",
    install: "تثبيت",
    notNow: "ليس الآن",
    
    backOnline: "تمت استعادة الاتصال بالإنترنت",
    offline: "غير متصل - لا يوجد اتصال بالإنترنت",
    
    language: "اللغة",
    selectLanguage: "اختر اللغة",

    // Settings
    settings: "الإعدادات",
    profileSettings: "إعدادات الملف الشخصي",
    profileDescription: "قم بتحديث معلوماتك الشخصية",
    changePassword: "تغيير كلمة المرور",
    passwordDescription: "قم بتحديث كلمة المرور لأمان حسابك",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "كلمة المرور الجديدة (تأكيد)",
    updatePassword: "تحديث كلمة المرور",
    saveChanges: "حفظ التغييرات",
    profileUpdated: "تم تحديث الملف الشخصي!",
    passwordChanged: "تم تغيير كلمة المرور!",
    passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل!",
    dangerZone: "منطقة الخطر",
    dangerDescription: "لا يمكن التراجع عن هذه الإجراءات",
    deleteAccount: "حذف الحساب",
    deleteAccountWarning: "تواصل مع الدعم لحذف حسابك",
    phone: "الهاتف",
    company: "اسم الشركة",
    address: "العنوان",

    // Navigation
    navHome: "الرئيسية",
    searchPlaceholder: "ابحث في العروض والعملاء والمستندات…",
    searching: "جارٍ البحث…",
    noResults: "لا توجد نتائج",
    navProposals: "عروض الأسعار",
    navTextDocs: "المستندات النصية",
    navCustomers: "العملاء",
    navReports: "التقارير",
    appTagline: "سريع، سهل، احترافي",
    userFallback: "المستخدم",
    loading: "جاري التحميل...",
    print: "طباعة",
    close: "إغلاق",
    all: "الكل",
    actions: "الإجراءات",
    dateLabel: "التاريخ",
    statusLabel: "الحالة",
    amountLabel: "المبلغ",
    statusApproved: "تمت الموافقة",
    downloadPdf: "تنزيل PDF",
    sendEmailTitle: "إرسال بريد إلكتروني",
    sendBtn: "إرسال",
    recipientEmail: "البريد الإلكتروني للمستلم",
    recipientName: "اسم المستلم",
    subjectLabel: "الموضوع",
    messageOptional: "الرسالة (اختياري)",
    messagePlaceholder: "رسالتك الخاصة (إذا تُركت فارغة تُستخدم رسالة افتراضية)",
    senderLabel: "المرسل",
    enterRecipientEmail: "يرجى إدخال البريد الإلكتروني للمستلم",
    emailSendFailed: "تعذر إرسال البريد الإلكتروني",
    deleteFailed: "فشل الحذف",
    updateFailed: "فشل التحديث",
    pdfGenerating: "جاري إنشاء PDF...",
    printPreparing: "جاري التحضير للطباعة...",
    printError: "خطأ في الطباعة",
    unknownError: "خطأ غير معروف",
    monthsShort: ["ينا", "فبر", "مار", "أبر", "ماي", "يون", "يول", "أغس", "سبت", "أكت", "نوف", "ديس"],

    // Proposals page
    proposalsSubtitle: "إدارة جميع عروض الأسعار الخاصة بك",
    proposalsLoadFailed: "تعذر تحميل عروض الأسعار",
    confirmDeleteProposal: "هل أنت متأكد من حذف هذا العرض؟",
    totalAmount: "المبلغ الإجمالي",
    searchProposalPlaceholder: "ابحث عن عرض أو عميل...",
    statusFilterLabel: "تصفية الحالة",
    sortLabel: "الترتيب",
    sortNewest: "الأحدث",
    sortOldest: "الأقدم",
    sortAmountDesc: "المبلغ (من الأعلى للأدنى)",
    sortAmountAsc: "المبلغ (من الأدنى للأعلى)",
    sortTitleAZ: "العنوان (أ-ي)",
    proposalList: "قائمة العروض",
    proposalWord: "عرض",
    noProposalsFound: "لا توجد عروض بعد",
    createFirstProposalBtn: "أنشئ العرض الأول",
    thProposal: "العرض",
    thCustomer: "العميل",
    untitledProposal: "عرض بدون عنوان",
    sendProposal: "إرسال العرض",
    sendDocument: "إرسال المستند",
    sendByEmailDesc: "سيتم إرساله بالبريد الإلكتروني",
    subjectProposalPrefix: "عرض سعر",
    subjectDocumentPrefix: "مستند",
    ocrCreated: "تم إنشاؤه بواسطة OCR",

    // Customers page
    customersSubtitle: "إدارة معلومات عملائك",
    newCustomer: "عميل جديد",
    totalCustomers: "إجمالي العملاء",
    searchCustomerPlaceholder: "ابحث عن عميل (الاسم، البريد، الهاتف، الشركة)...",
    noSearchResults: "لم يتم العثور على نتائج بحث",
    noCustomersYet: "لا يوجد عملاء بعد",
    addFirstCustomer: "أضف العميل الأول",
    editCustomer: "تعديل العميل",
    addNewCustomer: "إضافة عميل جديد",
    customerNameRequired: "اسم العميل مطلوب",
    customerUpdated: "تم تحديث العميل",
    customerAdded: "تمت إضافة العميل",
    customerSaveFailed: "تعذر حفظ العميل",
    customerDeleted: "تم حذف العميل",
    customerDeleteFailed: "تعذر حذف العميل",
    confirmDeleteCustomer: "— هل أنت متأكد من حذف هذا العميل؟",
    companyLabel: "الشركة",
    companyOptionalPlaceholder: "اسم الشركة (اختياري)",
    fullNamePlaceholder: "الاسم الكامل",
    fullAddressPlaceholder: "العنوان الكامل",
    customerNotesPlaceholder: "ملاحظات حول العميل...",
    taxOffice: "الدائرة الضريبية",
    taxOfficePlaceholder: "مثال: الرياض",
    taxNumber: "الرقم الضريبي",
    taxNumberPlaceholder: "الرقم الضريبي للتسجيل",
    tradeTitle: "الاسم التجاري",
    tradeTitlePlaceholder: "الاسم القانوني الكامل للشركة",
    mersisNo: "رقم MERSIS",
    mersisNoOptional: "رقم MERSIS (اختياري)",
    mersisNoPlaceholder: "رقم MERSIS المكون من 16 خانة",
    website: "الموقع الإلكتروني للشركة",
    websiteOptional: "الموقع الإلكتروني للشركة (اختياري)",
    websitePlaceholder: "https://example.com",
    fiscalInfoTitle: "المعلومات الضريبية والتجارية",
    senderEmailLabel: "بريد الرد (Reply-To)",
    senderEmailHelp: "عندما يضغط المستلم 'رد'، ستصل الرسالة إلى هذا العنوان. اتركه فارغًا لاستخدام بريد حسابك. ملاحظة: تُرسَل العروض من info@nktteklif.com؛ والردود تصل إليك.",
    replyToLabel: "الردود تصل إلى هنا",
    ownDomainGuideTitle: "أرسل من نطاقك الخاص — دليل Resend",
    ownDomainGuideIntro: "افتراضياً تُرسَل العروض من info@nktteklif.com الموثّق ويتم توجيه الردود إليك. لاستخدام نطاقك الخاص (مثل proposals@yourcompany.com) كمُرسل حقيقي، اتبع الخطوات التالية:",
    ownDomainStep1: "اذهب إلى resend.com وأنشئ حسابًا مجانيًا.",
    ownDomainStep2: "من القائمة اليسرى اضغط 'Domains' → 'Add Domain' → أدخل نطاقك (مثال: yourcompany.com).",
    ownDomainStep3: "سيعرض Resend 3 سجلات DNS (SPF، DKIM، MX). أضف هذه السجلات في لوحة DNS لدى مزوّد النطاق (GoDaddy، Namecheap، Cloudflare، إلخ).",
    ownDomainStep4: "اضغط 'Verify DNS' في Resend. قد يستغرق الانتشار 5–30 دقيقة.",
    ownDomainStep5: "بمجرد أن تتحول العلامة إلى الأخضر، اكتب proposals@yourcompany.com في هذا الحقل — ستُرسَل العروض من نطاقك.",
    ownDomainNote: "ملاحظة: العناوين الشخصية مثل Gmail أو Yahoo لا يمكن التحقق منها — تعمل فقط النطاقات التي تملكها.",
    ownDomainOpenResend: "فتح Resend",
    mailtoGreeting: "مرحبًا",
    mailtoBodyIntro: "أُرفق لكم العرض المطلوب.",
    mailtoAttachHint: "(تم تنزيل ملف PDF على جهازك — اسحبه وأفلته في هذا البريد لإرفاقه.)",
    mailtoRegards: "مع أطيب التحيات.",
    dataLoadFailed: "تعذر تحميل البيانات",
    createNewProposal: "إنشاء عرض سعر جديد",
    proposalsLabel: "عروض الأسعار",

    // Text documents
    textDocsSubtitle: "المستندات الممسوحة بواسطة OCR",
    newDocument: "مستند جديد",
    totalDocuments: "إجمالي المستندات",
    thisMonth: "هذا الشهر",
    quickScan: "مسح سريع",
    scanBtn: "مسح",
    searchDocPlaceholder: "ابحث عن مستند...",
    noDocumentsYet: "لا توجد مستندات نصية بعد",
    createNewDocument: "إنشاء مستند جديد",
    untitledDocument: "مستند بدون عنوان",
    documentsLoadFailed: "تعذر تحميل المستندات",
    confirmDeleteDocument: "هل أنت متأكد من حذف هذا المستند؟",
    documentDeleted: "تم حذف المستند",
    selectImageFile: "يرجى اختيار ملف صورة",
    fileTooBig: "الملف كبير جدًا. الحد الأقصى 25 ميجابايت",
    imageProcessFailed: "تعذرت معالجة الصورة",
    scanningImage: "جاري مسح الصورة...",
    scanSuccessRedirect: "تم المسح بنجاح! جاري التحويل إلى صفحة التحرير...",
    scanEmptyResult: "نتيجة المسح فارغة. يرجى تجربة صورة أوضح.",
    textEditorTitle: "محرر النص",
    saveAsText: "حفظ كنص",
    saveToDb: "حفظ في قاعدة البيانات",
    downloadAsPdf: "تنزيل كملف PDF",
    pdfFormat: "بصيغة PDF",
    sendToPrinter: "إرسال إلى الطابعة",
    docInfoTitle: "معلومات المستند",
    docNameLabel: "اسم المستند",
    docNamePlaceholder: "مثال: عقد - فيلا A",
    enterDocName: "أدخل اسم المستند...",
    textOnlyNote: "* يتم الحفظ كنص فقط.",
    customerContactInfo: "معلومات العميل والاتصال",
    selectCustomerLabel: "اختر العميل",
    selectCustomerPlaceholder: "اختر عميلاً موجودًا أو أضف جديدًا",
    customerNamePlaceholder: "الاسم الكامل للعميل",
    customerAddressPlaceholder: "عنوان العميل",
    fontLabel: "الخط:",
    boldTitle: "غامق",
    italicTitle: "مائل",
    underlineTitle: "تحته خط",
    strikeTitle: "يتوسطه خط",
    alignLeftTitle: "محاذاة لليسار",
    alignCenterTitle: "توسيط",
    alignRightTitle: "محاذاة لليمين",
    newDocBtn: "+ جديد",
    savedSuffix: "تم الحفظ",
    docUpdated: "✓ تم تحديث المستند!",
    docSaved: "✓ تم حفظ المستند!",
    saveFailed: "فشل الحفظ",
    enterAName: "يرجى إدخال اسم",
    textEmpty: "لا يمكن أن يكون النص فارغًا",
    noContentToPrint: "لا يوجد محتوى للطباعة",
    noContentForPdf: "لا يوجد محتوى لإنشاء PDF",
    printWindowOpened: "تم فتح نافذة الطباعة",
    popupBlocked: "مانع النوافذ المنبثقة نشط",
    writeTextHere: "اكتب النص هنا...",
    readyForNewDoc: "جاهز لمستند جديد",
    docLoadFailed: "تعذر تحميل المستند",
    pdfCreateFailed: "تعذر إنشاء PDF",

    // Settings page
    settingsSubtitle: "إدارة إعدادات شركتك وحسابك",
    settingsInfoBanner: "ستظهر هذه المعلومات في تذييل مخرجات العروض بصيغة PDF و JPG.",
    companyInfoDesc: "أدخل بيانات شركتك - ستظهر في تذييل PDF و JPG",
    logoNote: "PNG, JPG - الحد الأقصى 2 ميجابايت",
    websiteLabel: "الموقع الإلكتروني",
    letterheadTitle: "الورق الرسمي",
    letterheadDesc: "قم برفع ورقك الرسمي الجاهز بصيغة PNG/JPG. يوضع النص بين الهامش العلوي والسفلي اللذين تحددهما؛ الهوامش الجانبية قياسية 20 مم.",
    letterheadImageLabel: "صورة الورق الرسمي",
    letterheadNote: "PNG / JPG بحجم A4 (يتم الضغط تلقائيًا، الحد الأقصى 15 ميجابايت)",
    removeLetterhead: "إزالة الورق الرسمي",
    topMarginLabel: "الهامش العلوي",
    topMarginDesc: "مقدار المسافة التي يبدأ عندها النص من الأعلى",
    bottomMarginLabel: "الهامش السفلي",
    bottomMarginDesc: "مقدار المساحة المتروكة في الأسفل",
    letterheadNotUploaded: "لم يتم رفع ورق رسمي",
    textAreaLabel: "منطقة النص",
    textAreaHint: "توضع هنا",
    saveSettingsBtn: "حفظ الإعدادات",
    profitMarginTitle: "هامش الربح",
    profitMarginDesc: "يُضاف تلقائيًا إلى سعر كل بند مواد وعمالة عند إنشاء العرض. لا يظهر كسطر منفصل في مخرجات العميل (PDF/JPG). إذا كان \"0\" فلا يُضاف ربح.",
    profitMarginRateLabel: "نسبة هامش الربح (%)",
    saveProfitMarginBtn: "حفظ هامش الربح",
    profitMarginExample: "مثال: بند بقيمة 1,000 يُحسب في العرض كـ {amount}.",
    noProfitMargin: "لا يُطبق هامش ربح حاليًا.",
    accountInfoTitle: "معلومات الحساب",
    forgetMeBtn: "انسَني (جهاز مشترك)",
    forgetMeNote: "\"انسَني\": استخدم هذا إذا سجلت الدخول من جهاز شخص آخر — سيتم إغلاق جلسة Google على ذلك الجهاز وسيُطلب الحساب مجددًا عند الدخول التالي.",
    forgetMeConfirm: "انسَني: سيتم تسجيل خروجك وإغلاق جلسات Google على هذا الجهاز.\n\nاختر هذا إذا كنت تستخدم جهازًا مشتركًا — ستُطلب بيانات الحساب مجددًا عند الدخول التالي عبر Google.\n\nهل تريد المتابعة؟",
    settingsSaved: "تم حفظ الإعدادات! ستُستخدم في تصدير PDF و JPG.",
    settingsSaveFailed: "تعذر حفظ الإعدادات: ",
    logoTooBig: "يجب أن يكون ملف الشعار أصغر من 5 ميجابايت",
    logoPreparing: "جاري تحضير الشعار...",
    logoProcessFailed: "تعذرت معالجة الشعار: ",
    imagePreparing: "جاري تحضير الصورة...",
    imageUploaded: "تم رفع الصورة",
    imageTooBig: "يجب أن تكون الصورة أصغر من 15 ميجابايت",
    imageTooLargeError: "الصور المرفوعة كبيرة جدًا. يرجى تجربة صورة ورق رسمي أصغر (بحد أقصى 2-3 ميجابايت للملف الأصلي).",
    passwordChangedSuccess: "تم تغيير كلمة المرور بنجاح!",
    passwordChangeError: "خطأ في تغيير كلمة المرور",

    // Proposal editor
    editProposalDesc: "تعديل العرض الحالي",
    newProposalDesc: "إنشاء عرض سعر جديد",
    readyTemplate: "القوالب",
    readyTemplates: "قوالب جاهزة",
    myTemplates: "قوالبي",
    saveAsTemplateMenu: "حفظ هذا العرض كقالب",
    materialsLowerWord: "مواد",
    laborLowerWord: "عمالة",
    downloadingBtn: "جاري التنزيل...",
    shareWhatsAppLabel: "واتساب",
    shareWhatsAppTitle: "مشاركة PDF عبر واتساب",
    backToHomeTitle: "العودة إلى الرئيسية",
    projectProposalInfo: "معلومات المشروع والعرض",
    projectTitlePlaceholder: "مثال: مشروع سكني - فيلا A",
    proposalStatusLabel: "حالة العرض",
    selectStatusPlaceholder: "اختر الحالة",
    callLabel: "اتصال",
    materialCostTab: "تكاليف المواد",
    laborCostTab: "تكاليف العمالة",
    addImagesTab: "إضافة صور",
    noMaterialsYet: "لم تتم إضافة مواد بعد",
    noLaborYet: "لم تتم إضافة عمالة بعد",
    materialNameLabel: "اسم المادة",
    roomLabel: "الغرفة / القسم (اختياري)",
    roomPlaceholder: "مثال: غرفة النوم، المطبخ، الشرفة",
    ungroupedRoom: "عام",
    inProposalSearchPlaceholder: "ابحث في هذا العرض: مادة، عمالة، غرفة…",
    materialNamePlaceholder: "مثال: تبليط سيراميك",
    descriptionLabel: "الوصف",
    descriptionPlaceholder: "وصف تفصيلي",
    imagesMultiLabel: "الصور (يمكنك اختيار عدة صور)",
    materialTotalLabel: "إجمالي المواد:",
    laborTotalLabel: "إجمالي العمالة:",
    laborNameLabel: "اسم العمالة",
    laborNamePlaceholder: "مثال: تركيب سيراميك",
    attachmentsTitle: "الصور والمرفقات",
    attachmentsDesc: "صور، PDF، CAD — يمكن إرفاق أي نوع من الملفات. تظهر الصور في مخرجات PDF بالاسم والمعلومات؛ وتُضاف ملفات PDF المرفقة في نهاية المخرجات.",
    uploadingBtn: "جاري الرفع...",
    addAttachmentBtn: "إضافة صورة / ملف",
    noAttachmentsYet: "لم تتم إضافة ملفات بعد. استخدم \"إضافة صورة / ملف\" لاختيار صور أو PDF أو ملفات CAD (يدعم الاختيار المتعدد).",
    attachmentNameLabel: "اسم الصورة",
    attachmentInfoLabel: "معلومات / وصف",
    attachmentInfoPlaceholder: "مثال: منظر الواجهة الأمامية",
    kdvDiscountTitle: "ضريبة القيمة المضافة والخصم",
    kdvRateLabel: "نسبة ضريبة القيمة المضافة (%)",
    kdvAmountLabel: "مبلغ الضريبة:",
    discountRateLabel: "نسبة الخصم (%)",
    discountAmountLabel: "مبلغ الخصم:",
    discountWord: "خصم",
    profitIncludedTemplate: "هامش الربح ({pm}%) مشمول في الأسعار",
    invisibleToCustomer: "غير مرئي للعميل",
    subtotalColon: "المجموع الفرعي:",
    paymentTermsPlaceholder: "مثال: 50% مقدمًا، 50% عند التسليم",
    validityPlaceholder: "مثال: 30 يومًا",
    notesOtherTerms: "ملاحظات / شروط أخرى",
    notesPlaceholder: "ملاحظات أو شروط إضافية...",
    accountHolderPlaceholder: "اسم صاحب الحساب",
    bankNamePlaceholder: "مثال: البنك الأهلي",
    grandTotalCaps: "المجموع الكلي:",
    tplDialogTitle: "حفظ كقالب",
    tplNameLabel: "اسم القالب",
    tplNamePlaceholder: "مثال: تجديد حمام قياسي",
    tplSaveNote: "سيتم حفظ {m} بند مواد و {l} بند عمالة في القالب. يمكنك إضافتها لاحقًا بنقرة واحدة من قائمة \"القوالب\".",
    giveUpBtn: "إلغاء",
    enterTitleCustomer: "يرجى إدخال العنوان واسم العميل",
    proposalUpdated: "تم تحديث العرض",
    proposalCreated: "تم إنشاء العرض",
    proposalSaveFailed: "تعذر حفظ العرض",
    proposalLoadFailed: "تعذر تحميل العرض",
    templateAdded: "تمت إضافة القالب \"{name}\" — يمكنك تعديل الكميات والأسعار",
    templateNameRequired: "يرجى إدخال اسم القالب",
    noItemsForTemplate: "لا توجد بنود لحفظها في القالب",
    templateSaved: "تم حفظ القالب",
    templateSaveFailed: "تعذر حفظ القالب",
    templateDeleted: "تم حذف القالب",
    templateDeleteFailed: "تعذر حذف القالب",
    imagesUploaded: "تم رفع {n} صورة",
    imageUploadFailed: "تعذر رفع الصورة",
    imageDeleted: "تم حذف الصورة",
    filesAdded: "تمت إضافة {n} ملف",
    fileUploadFailed: "تعذر رفع الملف",
    fileRemoved: "تمت إزالة الملف",

    // Reports
    reportsTitle: "التقارير",
    reportsSubtitle: "إحصائيات عروضك وإيراداتك",
    approvalRate: "معدل الموافقة",
    approvedRevenue: "الإيرادات الموافق عليها",
    pendingColon: "قيد الانتظار:",
    estimatedProfit: "الربح التقديري",
    profitVisibilityNote: "من هامش الربح — مرئي لك فقط",
    monthlyChartTitle: "العروض والإيرادات الشهرية (آخر 12 شهرًا)",
    statusDistribution: "توزيع الحالات",
    topCategoriesTitle: "الفئات الأكثر استخدامًا",
    noCategoryData: "لا توجد بيانات فئات بعد",
    itemsWord: "بند",
    topCustomersTitle: "الإيرادات حسب العميل (أعلى 10)",
    noCustomerData: "لا توجد بيانات عملاء بعد",
    reportsLoadFailed: "تعذر تحميل بيانات التقرير",

    // Smart fields
    categoryLabel: "الفئة",
    selectCategoryPlaceholder: "اختر الفئة",
    subCategoryLabel: "الفئة الفرعية",
    selectSubCategoryPlaceholder: "اختر الفئة الفرعية",
    detailLabel: "التفاصيل / الميزة",
    selectDetailPlaceholder: "اختر التفاصيل",
    measureCalcLabel: "الحساب بالقياس (بالمتر)",
    widthLabel: "العرض",
    lengthLabel: "الطول",
    heightLabel: "الارتفاع",
    heightOptLabel: "الارتفاع (اختياري)",
    autoTransferred: "تم النقل تلقائيًا إلى الكمية",
    hideCalcTable: "إخفاء جدول الحساب",
    getPriceBtn: "الحصول على السعر",
    gettingPrice: "جاري الحصول على السعر...",
    enterItemFirst: "أدخل اسم البند أو اختر فئة أولاً",
    aiPriceFailed: "تعذر الحصول على تقدير السعر بالذكاء الاصطناعي، يرجى المحاولة مرة أخرى",
    noPriceToApply: "لم يتم العثور على سعر للتطبيق",
    priceApplied: "تم تطبيق سعر الوحدة",
    applyMaterialBtn: "تطبيق المواد",
    applyLaborBtn: "تطبيق العمالة",
    avgLabel: "متوسط",

    // Reset password
    newPasswordTitle: "تعيين كلمة مرور جديدة",
    newPasswordDesc: "أنشئ كلمة مرور جديدة لحسابك",
    invalidLink: "رابط غير صالح",
    invalidLinkDesc: "رابط إعادة تعيين كلمة المرور غير صالح أو مفقود. يرجى طلب إعادة تعيين جديدة.",
    backToHome: "العودة إلى الصفحة الرئيسية",
    changePasswordBtn: "تغيير كلمة المرور",
    passwordResetSuccess: "تم تغيير كلمة المرور بنجاح!",
    passwordResetFailed: "فشلت إعادة تعيين كلمة المرور. قد يكون الرابط غير صالح أو منتهي الصلاحية.",

    // Landing extras
    featureMaterialTitle: "إدارة المواد",
    featureMaterialDesc: "قوائم مواد تفصيلية، أسعار الوحدات، صور وحساب تلقائي للمجموع.",
    featureLaborTitle: "العمالة وضريبة القيمة المضافة",
    featureLaborDesc: "تكاليف العمالة وحسابات الضريبة وإدارة العمولات في منصة واحدة.",
    featurePdfTitle: "تصدير PDF",
    featurePdfDesc: "مخرجات PDF احترافية، جاهزة بشعار الشركة وبيانات العميل.",
    footerDesc: "منصة احترافية لإعداد عروض الأسعار. قم بحسابات المواد والعمالة والتكاليف بسهولة.",
    footerRights: "© 2025 NKT للتصميم. جميع الحقوق محفوظة.",
    helpTitle: "المساعدة",
    contactUs: "اتصل بنا",
    faqLink: "الأسئلة الشائعة",
    supportLink: "الدعم",
    termsLink: "الشروط والأحكام",
    servicesTitle: "الخدمات",
    serviceLaborKdv: "حساب العمالة وضريبة القيمة المضافة",
    serviceCost: "حساب التكاليف",
    servicePdfJpg: "تصدير PDF و JPG",
    communityTitle: "المجتمع",
    footerSlogan: "شريكك الموثوق لمشاريع التصميم والديكور",
    resetLinkSentKnown: "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
    resetLinkSentGeneric: "إذا كان البريد الإلكتروني مسجلاً، فقد تم إرسال رابط إعادة التعيين",
    genericError: "حدث خطأ",
    imageTooBig2MB: "يجب أن تكون الصورة أصغر من 2 ميجابايت",

    // Auth & misc extras
    optionalWord: "(اختياري)",
    loginErrCreds: "البريد الإلكتروني أو كلمة المرور غير صحيحة. إذا نسيت كلمة المرور استخدم رابط 'نسيت كلمة المرور'.",
    loginErrNotFound: "لا يوجد مستخدم مسجل بهذا البريد الإلكتروني. يرجى التسجيل أولاً من 'تسجيل'.",
    loginErrNetwork: "تعذر الوصول إلى الخادم. تحقق من اتصالك بالإنترنت أو حاول مرة أخرى بعد قليل.",
    loginErrGeneric: "تعذر تسجيل الدخول",
    authSessionNotFound: "الجلسة غير موجودة",
    authFailed: "فشلت المصادقة",
    authenticating: "جاري التحقق من الهوية...",
    authNotMe: "هذا ليس أنا — الدخول بحساب مختلف",
    authNotMeNote: "إذا تم اختيار \"هذا ليس أنا\" يتم إغلاق جلسة Google على هذا الجهاز وسيُطلب الحساب مجددًا عند الدخول التالي.",
    qtyApplied: "تم تطبيق الكمية",
    calcEnterHint: "أدخل القياسات — ستظهر النتائج تلقائيًا",
    pdfOpenedPrintHint: "تم فتح PDF. يمكنك الطباعة من قائمة المتصفح.",
    applyBtn: "تطبيق",
    applyToQuantity: "تطبيق على الكمية",
    authContinueQuestion: "هل تريد المتابعة بهذا الحساب؟",
    authContinueYes: "نعم، متابعة",
    wallAreaFormula: "مساحة الجدار = 2×(العرض+الطول)×الارتفاع",
    termsConditions: "الشروط والأحكام",
    singleWallFormula: "جدار واحد = العرض×الارتفاع",
    floorAreaFormula: "مساحة الأرضية = العرض×الطول"
  },
  
  fr: {
    professionalSystem: "Système de Devis Professionnel",
    forWhomTitle: "Pour Qui ?",
    forWhomDesc: "Une seule plateforme pour les projets d'architecture, d'architecture d'intérieur et de décoration, les devis de rénovation et de construction.",
    audArchitects: "Architectes",
    audInterior: "Architectes d'Intérieur",
    audDecorators: "Décorateurs",
    audContractors: "Entreprises de Rénovation & Construction",
    audCraftsmen: "Artisans",
    appTitle: "NKT - Devis",
    appSubtitle: "Créateur",
    appDescription: "Logiciel de devis pour architectes, architectes d'intérieur et décorateurs : créez des devis PDF professionnels en quelques minutes avec calculs de matériaux, main-d'œuvre, TVA et remises.",
    login: "Connexion",
    register: "S'inscrire",
    or: "ou",
    loginWithGoogle: "Connexion avec Google",
    microCTA: "Créez votre premier devis en 60 secondes",
    galleryTitle: "Exemples de Devis",
    galleryDesc: "Exemples réels de devis créés par nos utilisateurs",
    galleryBadge: "PDF Exemple",
    galleryProject1: "Rénovation Villa",
    galleryProject2: "Rénovation Bureau",
    galleryProject3: "Installation Toiture",
    galleryScope1: "Salon · Cuisine · Bain",
    galleryScope2: "Sol · Peinture · Électricité",
    galleryScope3: "Panneau · Tôle · Gouttière",
    galleryMaterial: "Matériaux",
    galleryLabor: "Main-d'œuvre",
    galleryVat: "TVA 20%",
    galleryTotal: "Total Général",
    galleryCurrency: "€",
    
    loginTitle: "Connexion",
    loginSubtitle: "Connectez-vous à votre compte",
    email: "E-mail",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié",
    loggingIn: "Connexion en cours...",
    cancel: "Annuler",
    
    registerTitle: "Inscription",
    registerSubtitle: "Créer un nouveau compte",
    fullName: "Nom Complet",
    passwordConfirm: "Confirmer le mot de passe",
    minChars: "Au moins 6 caractères",
    registering: "Inscription en cours...",
    profilePicture: "Photo de Profil",
    maxFileSize: "Maximum 2 Mo",
    
    forgotPasswordTitle: "Mot de passe oublié",
    forgotPasswordSubtitle: "Nous vous enverrons un lien de réinitialisation par e-mail",
    sendLink: "Envoyer le lien",
    sending: "Envoi en cours...",
    backToLogin: "Retour à la connexion",
    
    // Dashboard
    panel: "Tableau de Bord",
    dashboardOverview: "Aperçu de vos devis",
    totalProposals: "Total Devis",
    approved: "Approuvés",
    pending: "En Attente",
    awaitingResponse: "En Attente de Réponse",
    totalRevenue: "Revenus Totaux",
    monthlyProposals: "Devis Mensuels",
    statusSummary: "Résumé du Statut",
    draft: "Brouillon",
    sent: "Envoyé",
    rejected: "Rejeté",
    pendingRevenue: "Revenus en Attente",
    recentProposals: "Devis Récents",
    viewAll: "Voir Tout",
    noProposalsYet: "Aucun devis pour le moment",
    createFirstProposal: "Créez Votre Premier Devis",
    myProposals: "Mes Devis",
    newProposal: "Nouveau Devis",
    noProposals: "Vous n'avez pas encore créé de devis",
    startFirstProposal: "Commencez à créer votre premier devis maintenant",
    createProposal: "Créer un Devis",
    edit: "Modifier",
    delete: "Supprimer",
    material: "Matériau",
    labor: "Main-d'œuvre",
    kdv: "TVA",
    commission: "Commission",
    total: "Total",
    logout: "Déconnexion",
    statusUpdateFailed: "Échec de la mise à jour du statut",
    statusUpdated: "Statut mis à jour",
    
    // OCR - Image to Text
    scanImage: "Scanner Image",
    scanImageDesc: "Convertissez vos devis manuscrits en numérique avec l'IA",
    uploadImage: "Télécharger Image",
    scanning: "Scan en cours...",
    scanComplete: "Scan terminé",
    scanFailed: "Échec du scan",
    extractedText: "Texte Extrait",
    useThisText: "Utiliser Ce Texte",
    textEditor: "Éditeur de Texte",
    clearText: "Effacer le Texte",
    
    editProposal: "Modifier le Devis",
    newProposalTitle: "Nouveau Devis",
    save: "Enregistrer",
    saving: "Enregistrement...",
    
    generalInfo: "Informations Générales",
    projectTitle: "Titre du Projet",
    customerName: "Nom du Client",
    customerPhone: "Téléphone du Client",
    customerEmail: "E-mail du Client",
    customerAddress: "Adresse du Client",
    companyName: "Nom de l'Entreprise",
    companyLogo: "Logo de l'Entreprise",
    
    materials: "Matériaux",
    laborItems: "Main-d'œuvre",
    addMaterial: "Ajouter un Matériau",
    addLabor: "Ajouter Main-d'œuvre",
    itemName: "Nom de l'Article",
    quantity: "Quantité",
    unit: "Unité",
    unitPrice: "Prix Unitaire",
    images: "Images",
    
    summary: "Résumé",
    subtotal: "Sous-total",
    kdvRate: "Taux de TVA",
    commissionRate: "Taux de Commission",
    grandTotal: "Total Général",
    
    termsAndConditions: "Termes et Conditions",
    paymentTerms: "Conditions de Paiement",
    validityPeriod: "Période de Validité",
    notes: "Notes",
    bankInfo: "Informations Bancaires",
    accountHolder: "Titulaire du Compte",
    bankName: "Nom de la Banque",
    iban: "IBAN",
    
    loginSuccess: "Connexion réussie !",
    loginFailed: "Échec de la connexion",
    registerSuccess: "Inscription réussie !",
    registerFailed: "Échec de l'inscription",
    passwordMismatch: "Les mots de passe ne correspondent pas !",
    passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
    proposalSaved: "Devis enregistré",
    proposalDeleted: "Devis supprimé",
    pdfDownloaded: "PDF téléchargé",
    jpgDownloaded: "JPG téléchargé",
    downloadFailed: "Échec du téléchargement",
    
    // PDF Export Labels
    pdfCustomerInfo: "Informations Client",
    pdfCompanyInfo: "Informations Entreprise",
    pdfCustomerName: "nom du client",
    pdfPhone: "téléphone",
    pdfAddress: "adresse",
    pdfEmail: "e-mail",
    pdfCompanyName: "nom de l'entreprise",
    pdfWebsite: "site web",
    pdfMaterialCosts: "Coûts des Matériaux",
    pdfLaborCosts: "Coûts de Main-d'œuvre",
    pdfImage: "Image",
    pdfMaterialDesc: "Matériau / Description",
    pdfLaborDesc: "Main-d'œuvre / Description",
    pdfCategory: "Catégorie",
    pdfUnit: "Unité",
    pdfUnitPrice: "Prix Unitaire",
    pdfTotal: "Total",
    pdfMaterialTotal: "Total Matériaux",
    pdfLaborTotal: "Total Main-d'œuvre",
    pdfTermsConditions: "Termes et Conditions",
    pdfBankInfo: "Informations Bancaires",
    pdfPaymentTerms: "Conditions de Paiement",
    pdfAccountHolder: "Titulaire du Compte",
    pdfValidityPeriod: "Période de Validité du Devis",
    pdfBankName: "Banque",
    pdfNotes: "Notes / Autres Termes",
    pdfIban: "IBAN",
    pdfSubtotal: "Sous-total",
    pdfKdv: "TVA",
    pdfCommission: "Commission",
    pdfGrandTotal: "Total Général",
    pdfCompanyLogo: "Logo de l'entreprise",
    
    installApp: "Installer l'Application",
    installDescription: "Installez NKT Devis pour un accès plus rapide",
    install: "Installer",
    notNow: "Pas Maintenant",
    
    backOnline: "Connexion internet rétablie",
    offline: "Hors ligne - Pas de connexion internet",
    
    language: "Langue",
    selectLanguage: "Sélectionner la Langue",

    // Settings
    settings: "Paramètres",
    profileSettings: "Paramètres du Profil",
    profileDescription: "Mettez à jour vos informations personnelles",
    changePassword: "Changer le Mot de Passe",
    passwordDescription: "Mettez à jour votre mot de passe pour la sécurité de votre compte",
    currentPassword: "Mot de Passe Actuel",
    newPassword: "Nouveau Mot de Passe",
    confirmNewPassword: "Nouveau Mot de Passe (Confirmer)",
    updatePassword: "Mettre à Jour le Mot de Passe",
    saveChanges: "Enregistrer les Modifications",
    profileUpdated: "Profil mis à jour !",
    passwordChanged: "Mot de passe changé !",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères !",
    dangerZone: "Zone Dangereuse",
    dangerDescription: "Ces actions sont irréversibles",
    deleteAccount: "Supprimer le Compte",
    deleteAccountWarning: "Contactez le support pour supprimer votre compte",
    phone: "Téléphone",
    company: "Nom de l'Entreprise",
    address: "Adresse",

    // Navigation
    navHome: "Accueil",
    searchPlaceholder: "Rechercher devis, clients ou docs…",
    searching: "Recherche…",
    noResults: "Aucun résultat",
    navProposals: "Devis",
    navTextDocs: "Documents Texte",
    navCustomers: "Clients",
    navReports: "Rapports",
    appTagline: "Rapide, facile, professionnel",
    userFallback: "Utilisateur",
    loading: "Chargement...",
    print: "Imprimer",
    close: "Fermer",
    all: "Tous",
    actions: "Actions",
    dateLabel: "Date",
    statusLabel: "Statut",
    amountLabel: "Montant",
    statusApproved: "Approuvé",
    downloadPdf: "Télécharger le PDF",
    sendEmailTitle: "Envoyer un E-mail",
    sendBtn: "Envoyer",
    recipientEmail: "E-mail du Destinataire",
    recipientName: "Nom du Destinataire",
    subjectLabel: "Objet",
    messageOptional: "Message (Optionnel)",
    messagePlaceholder: "Votre message personnalisé (un message par défaut est utilisé si laissé vide)",
    senderLabel: "Expéditeur",
    enterRecipientEmail: "Veuillez saisir l'adresse e-mail du destinataire",
    emailSendFailed: "L'e-mail n'a pas pu être envoyé",
    deleteFailed: "Échec de la suppression",
    updateFailed: "Échec de la mise à jour",
    pdfGenerating: "Génération du PDF...",
    printPreparing: "Préparation de l'impression...",
    printError: "Erreur d'impression",
    unknownError: "Erreur inconnue",
    monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],

    // Proposals page
    proposalsSubtitle: "Gérez tous vos devis",
    proposalsLoadFailed: "Les devis n'ont pas pu être chargés",
    confirmDeleteProposal: "Êtes-vous sûr de vouloir supprimer ce devis ?",
    totalAmount: "Montant Total",
    searchProposalPlaceholder: "Rechercher un devis ou un client...",
    statusFilterLabel: "Filtre de Statut",
    sortLabel: "Tri",
    sortNewest: "Plus Récent",
    sortOldest: "Plus Ancien",
    sortAmountDesc: "Montant (Décroissant)",
    sortAmountAsc: "Montant (Croissant)",
    sortTitleAZ: "Titre (A-Z)",
    proposalList: "Liste des Devis",
    proposalWord: "devis",
    noProposalsFound: "Aucun devis pour le moment",
    createFirstProposalBtn: "Créer le Premier Devis",
    thProposal: "Devis",
    thCustomer: "Client",
    untitledProposal: "Devis Sans Titre",
    sendProposal: "Envoyer le Devis",
    sendDocument: "Envoyer le Document",
    sendByEmailDesc: "sera envoyé par e-mail",
    subjectProposalPrefix: "Devis",
    subjectDocumentPrefix: "Document",
    ocrCreated: "Créé avec OCR",

    // Customers page
    customersSubtitle: "Gérez les informations de vos clients",
    newCustomer: "Nouveau Client",
    totalCustomers: "Total Clients",
    searchCustomerPlaceholder: "Rechercher un client (nom, e-mail, téléphone, entreprise)...",
    noSearchResults: "Aucun résultat trouvé",
    noCustomersYet: "Aucun client pour le moment",
    addFirstCustomer: "Ajouter le Premier Client",
    editCustomer: "Modifier le Client",
    addNewCustomer: "Ajouter un Nouveau Client",
    customerNameRequired: "Le nom du client est requis",
    customerUpdated: "Client mis à jour",
    customerAdded: "Client ajouté",
    customerSaveFailed: "Le client n'a pas pu être enregistré",
    customerDeleted: "Client supprimé",
    customerDeleteFailed: "Le client n'a pas pu être supprimé",
    confirmDeleteCustomer: "— êtes-vous sûr de vouloir supprimer ce client ?",
    companyLabel: "Entreprise",
    companyOptionalPlaceholder: "Nom de l'entreprise (optionnel)",
    fullNamePlaceholder: "Nom Complet",
    fullAddressPlaceholder: "Adresse complète",
    customerNotesPlaceholder: "Notes sur le client...",
    taxOffice: "Bureau des Impôts",
    taxOfficePlaceholder: "Ex: Paris",
    taxNumber: "Numéro Fiscal / TVA",
    taxNumberPlaceholder: "Numéro d'identification fiscale",
    tradeTitle: "Raison Sociale",
    tradeTitlePlaceholder: "Dénomination légale complète",
    mersisNo: "Numéro MERSIS",
    mersisNoOptional: "Numéro MERSIS (facultatif)",
    mersisNoPlaceholder: "Numéro MERSIS à 16 chiffres",
    website: "Site Web de l'Entreprise",
    websiteOptional: "Site Web de l'Entreprise (facultatif)",
    websitePlaceholder: "https://exemple.com",
    fiscalInfoTitle: "Informations Fiscales & Commerciales",
    senderEmailLabel: "Mon e-mail de Réponse (Reply-To)",
    senderEmailHelp: "Lorsque le destinataire clique sur 'Répondre', le message arrive à cette adresse. Laissez vide pour utiliser l'e-mail du compte. Note : les devis sont envoyés depuis info@nktteklif.com ; les réponses vous parviennent.",
    replyToLabel: "Les réponses arrivent ici",
    ownDomainGuideTitle: "Envoyer depuis votre propre domaine — Guide Resend",
    ownDomainGuideIntro: "Par défaut, les devis partent de notre info@nktteklif.com vérifié et les réponses vous sont redirigées. Pour utiliser votre propre domaine (ex. devis@votresociete.com) comme véritable expéditeur, suivez ces étapes :",
    ownDomainStep1: "Allez sur resend.com et créez un compte gratuit.",
    ownDomainStep2: "Dans le menu de gauche, cliquez sur 'Domains' → 'Add Domain' → saisissez votre domaine (ex. votresociete.com).",
    ownDomainStep3: "Resend affichera 3 enregistrements DNS (SPF, DKIM, MX). Ajoutez ces enregistrements dans le panneau DNS de votre fournisseur (GoDaddy, Namecheap, Cloudflare, etc.).",
    ownDomainStep4: "Cliquez sur 'Verify DNS' dans Resend. La propagation peut prendre 5 à 30 minutes.",
    ownDomainStep5: "Une fois la vérification en vert, saisissez devis@votresociete.com dans ce champ — les devis partiront de votre propre domaine.",
    ownDomainNote: "Remarque : les adresses personnelles comme Gmail ou Yahoo ne peuvent pas être vérifiées — seuls les domaines que vous possédez fonctionnent.",
    ownDomainOpenResend: "Ouvrir Resend",
    mailtoGreeting: "Bonjour",
    mailtoBodyIntro: "Veuillez trouver ci-joint le devis demandé.",
    mailtoAttachHint: "(Le PDF a été téléchargé sur votre ordinateur — faites-le glisser dans cet e-mail pour l'attacher.)",
    mailtoRegards: "Cordialement.",
    dataLoadFailed: "Les données n'ont pas pu être chargées",
    createNewProposal: "Créer un Nouveau Devis",
    proposalsLabel: "Devis",

    // Text documents
    textDocsSubtitle: "Documents numérisés avec OCR",
    newDocument: "Nouveau Document",
    totalDocuments: "Total Documents",
    thisMonth: "Ce Mois-ci",
    quickScan: "Scan Rapide",
    scanBtn: "Scanner",
    searchDocPlaceholder: "Rechercher un document...",
    noDocumentsYet: "Aucun document texte pour le moment",
    createNewDocument: "Créer un Nouveau Document",
    untitledDocument: "Document Sans Titre",
    documentsLoadFailed: "Les documents n'ont pas pu être chargés",
    confirmDeleteDocument: "Êtes-vous sûr de vouloir supprimer ce document ?",
    documentDeleted: "Document supprimé",
    selectImageFile: "Veuillez sélectionner un fichier image",
    fileTooBig: "Fichier trop volumineux. Maximum 25 Mo",
    imageProcessFailed: "L'image n'a pas pu être traitée",
    scanningImage: "Numérisation de l'image...",
    scanSuccessRedirect: "Scan réussi ! Redirection vers l'éditeur...",
    scanEmptyResult: "Le résultat du scan est vide. Veuillez essayer une image plus nette.",
    textEditorTitle: "Éditeur de Texte",
    saveAsText: "Enregistrer comme Texte",
    saveToDb: "Enregistrer dans la base de données",
    downloadAsPdf: "Télécharger en PDF",
    pdfFormat: "Au format PDF",
    sendToPrinter: "Envoyer à l'imprimante",
    docInfoTitle: "Informations du Document",
    docNameLabel: "Nom du Document",
    docNamePlaceholder: "Ex : Contrat - Villa A",
    enterDocName: "Saisissez le nom du document...",
    textOnlyNote: "* Enregistré uniquement comme texte.",
    customerContactInfo: "Informations Client et Contact",
    selectCustomerLabel: "Sélectionner un Client",
    selectCustomerPlaceholder: "Sélectionnez un client existant ou ajoutez-en un nouveau",
    customerNamePlaceholder: "Nom complet du client",
    customerAddressPlaceholder: "Adresse du client",
    fontLabel: "Police :",
    boldTitle: "Gras",
    italicTitle: "Italique",
    underlineTitle: "Souligné",
    strikeTitle: "Barré",
    alignLeftTitle: "Aligner à Gauche",
    alignCenterTitle: "Centrer",
    alignRightTitle: "Aligner à Droite",
    newDocBtn: "+ Nouveau",
    savedSuffix: "enregistré",
    docUpdated: "✓ Document mis à jour !",
    docSaved: "✓ Document enregistré !",
    saveFailed: "Échec de l'enregistrement",
    enterAName: "Veuillez saisir un nom",
    textEmpty: "Le texte ne peut pas être vide",
    noContentToPrint: "Aucun contenu à imprimer",
    noContentForPdf: "Aucun contenu pour créer le PDF",
    printWindowOpened: "Fenêtre d'impression ouverte",
    popupBlocked: "Le bloqueur de pop-up est actif",
    writeTextHere: "Écrivez votre texte ici...",
    readyForNewDoc: "Prêt pour un nouveau document",
    docLoadFailed: "Le document n'a pas pu être chargé",
    pdfCreateFailed: "Le PDF n'a pas pu être créé",

    // Settings page
    settingsSubtitle: "Gérez les paramètres de votre entreprise et de votre compte",
    settingsInfoBanner: "Ces informations seront affichées dans le pied de page de vos exports de devis PDF et JPG.",
    companyInfoDesc: "Saisissez les informations de votre entreprise - affichées dans le pied de page PDF et JPG",
    logoNote: "PNG, JPG - Maximum 2 Mo",
    websiteLabel: "Site Web",
    letterheadTitle: "Papier à En-tête",
    letterheadDesc: "Téléchargez votre papier à en-tête prêt en PNG/JPG. Le texte est placé entre les marges haute et basse que vous définissez ; les marges latérales sont standard à 20 mm.",
    letterheadImageLabel: "Image du Papier à En-tête",
    letterheadNote: "PNG / JPG au format A4 (compression automatique, max 15 Mo)",
    removeLetterhead: "Retirer le papier à en-tête",
    topMarginLabel: "Marge Supérieure",
    topMarginDesc: "À quelle distance du haut le texte doit commencer",
    bottomMarginLabel: "Marge Inférieure",
    bottomMarginDesc: "Combien d'espace laisser en bas",
    letterheadNotUploaded: "Aucun papier à en-tête téléchargé",
    textAreaLabel: "Zone de texte",
    textAreaHint: "se place ici",
    saveSettingsBtn: "Enregistrer les Paramètres",
    profitMarginTitle: "Marge Bénéficiaire",
    profitMarginDesc: "Ajoutée automatiquement au prix de chaque article de matériaux et de main-d'œuvre lors de la création d'un devis. Elle n'apparaît pas comme ligne séparée dans les sorties client (PDF/JPG). Si \"0\", aucun bénéfice n'est ajouté.",
    profitMarginRateLabel: "Taux de Marge Bénéficiaire (%)",
    saveProfitMarginBtn: "Enregistrer la Marge",
    profitMarginExample: "Exemple : un article de 1 000 est calculé à {amount} dans le devis.",
    noProfitMargin: "Aucune marge bénéficiaire n'est actuellement appliquée.",
    accountInfoTitle: "Informations du Compte",
    forgetMeBtn: "Oubliez-moi (Ordinateur Partagé)",
    forgetMeNote: "\"Oubliez-moi\" : Utilisez ceci si vous vous êtes connecté depuis l'ordinateur de quelqu'un d'autre — votre session Google sur cet appareil sera aussi fermée et le compte sera redemandé à la prochaine connexion.",
    forgetMeConfirm: "Oubliez-moi : Vous serez déconnecté ET vos sessions Google sur cet appareil seront fermées.\n\nChoisissez ceci si vous utilisez un ordinateur partagé — les informations du compte seront redemandées à la prochaine connexion Google.\n\nContinuer ?",
    settingsSaved: "Paramètres enregistrés ! Ils seront utilisés dans les exports PDF et JPG.",
    settingsSaveFailed: "Les paramètres n'ont pas pu être enregistrés : ",
    logoTooBig: "Le fichier du logo doit être inférieur à 5 Mo",
    logoPreparing: "Préparation du logo...",
    logoProcessFailed: "Le logo n'a pas pu être traité : ",
    imagePreparing: "Préparation de l'image...",
    imageUploaded: "Image téléchargée",
    imageTooBig: "L'image doit être inférieure à 15 Mo",
    imageTooLargeError: "Les images téléchargées sont trop volumineuses. Veuillez essayer une image de papier à en-tête plus petite (max 2-3 Mo fichier original).",
    passwordChangedSuccess: "Mot de passe changé avec succès !",
    passwordChangeError: "Erreur de changement de mot de passe",

    // Proposal editor
    editProposalDesc: "Modifiez le devis existant",
    newProposalDesc: "Créez un nouveau devis",
    readyTemplate: "Modèles",
    readyTemplates: "Modèles Prêts",
    myTemplates: "Mes Modèles",
    saveAsTemplateMenu: "Enregistrer ce Devis comme Modèle",
    materialsLowerWord: "matériaux",
    laborLowerWord: "main-d'œuvre",
    downloadingBtn: "Téléchargement...",
    shareWhatsAppLabel: "WhatsApp",
    shareWhatsAppTitle: "Partager PDF via WhatsApp",
    backToHomeTitle: "Retour à l'accueil",
    projectProposalInfo: "Informations du Projet et du Devis",
    projectTitlePlaceholder: "Ex : Projet Résidentiel - Villa A",
    proposalStatusLabel: "Statut du Devis",
    selectStatusPlaceholder: "Sélectionner le statut",
    callLabel: "Appeler",
    materialCostTab: "Coûts des Matériaux",
    laborCostTab: "Coûts de Main-d'œuvre",
    addImagesTab: "Ajouter des Images",
    noMaterialsYet: "Aucun matériau ajouté pour le moment",
    noLaborYet: "Aucune main-d'œuvre ajoutée pour le moment",
    materialNameLabel: "Nom du Matériau",
    roomLabel: "Pièce / Section (facultatif)",
    roomPlaceholder: "Ex: Chambre, Cuisine, Balcon",
    ungroupedRoom: "Général",
    inProposalSearchPlaceholder: "Rechercher dans ce devis : matériau, main-d'œuvre, pièce…",
    materialNamePlaceholder: "Ex : Carrelage Céramique",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Description détaillée",
    imagesMultiLabel: "Images (vous pouvez en sélectionner plusieurs)",
    materialTotalLabel: "Total Matériaux :",
    laborTotalLabel: "Total Main-d'œuvre :",
    laborNameLabel: "Nom de la Main-d'œuvre",
    laborNamePlaceholder: "Ex : Pose de Céramique",
    attachmentsTitle: "Images et Pièces Jointes",
    attachmentsDesc: "Images, PDF, CAD — tout type de fichier peut être joint. Les images apparaissent dans le PDF avec nom et informations ; les PDF joints sont ajoutés à la fin.",
    uploadingBtn: "Téléchargement...",
    addAttachmentBtn: "Ajouter Image / Fichier",
    noAttachmentsYet: "Aucun fichier ajouté. Utilisez \"Ajouter Image / Fichier\" pour sélectionner des images, PDF ou fichiers CAD (sélection multiple prise en charge).",
    attachmentNameLabel: "Nom de l'Image",
    attachmentInfoLabel: "Info / Description",
    attachmentInfoPlaceholder: "Ex : Vue de la façade avant",
    kdvDiscountTitle: "TVA et Remise",
    kdvRateLabel: "Taux de TVA (%)",
    kdvAmountLabel: "Montant TVA :",
    discountRateLabel: "Taux de Remise (%)",
    discountAmountLabel: "Montant de la Remise :",
    discountWord: "Remise",
    profitIncludedTemplate: "Marge bénéficiaire ({pm}%) incluse dans les prix",
    invisibleToCustomer: "invisible pour le client",
    subtotalColon: "Sous-total :",
    paymentTermsPlaceholder: "Ex : 50% d'acompte, 50% à la livraison",
    validityPlaceholder: "Ex : 30 jours",
    notesOtherTerms: "Notes / Autres Conditions",
    notesPlaceholder: "Notes ou conditions supplémentaires...",
    accountHolderPlaceholder: "Nom du titulaire du compte",
    bankNamePlaceholder: "Ex : Banque Nationale",
    grandTotalCaps: "TOTAL GÉNÉRAL :",
    tplDialogTitle: "Enregistrer comme Modèle",
    tplNameLabel: "Nom du Modèle",
    tplNamePlaceholder: "Ex : Rénovation Standard de Salle de Bain",
    tplSaveNote: "Les {m} articles de matériaux et {l} articles de main-d'œuvre actuels seront enregistrés dans le modèle. Vous pourrez les ajouter plus tard en un clic depuis le menu \"Modèles\".",
    giveUpBtn: "Annuler",
    enterTitleCustomer: "Veuillez saisir un titre et le nom du client",
    proposalUpdated: "Devis mis à jour",
    proposalCreated: "Devis créé",
    proposalSaveFailed: "Le devis n'a pas pu être enregistré",
    proposalLoadFailed: "Le devis n'a pas pu être chargé",
    templateAdded: "Modèle \"{name}\" ajouté — vous pouvez modifier les quantités et les prix",
    templateNameRequired: "Veuillez saisir un nom de modèle",
    noItemsForTemplate: "Aucun article à enregistrer dans le modèle",
    templateSaved: "Modèle enregistré",
    templateSaveFailed: "Le modèle n'a pas pu être enregistré",
    templateDeleted: "Modèle supprimé",
    templateDeleteFailed: "Le modèle n'a pas pu être supprimé",
    imagesUploaded: "{n} images téléchargées",
    imageUploadFailed: "L'image n'a pas pu être téléchargée",
    imageDeleted: "Image supprimée",
    filesAdded: "{n} fichiers ajoutés",
    fileUploadFailed: "Le fichier n'a pas pu être téléchargé",
    fileRemoved: "Fichier retiré",

    // Reports
    reportsTitle: "Rapports",
    reportsSubtitle: "Vos statistiques de devis et de revenus",
    approvalRate: "Taux d'Approbation",
    approvedRevenue: "Revenus Approuvés",
    pendingColon: "En attente :",
    estimatedProfit: "Bénéfice Estimé",
    profitVisibilityNote: "De la marge bénéficiaire — visible uniquement par vous",
    monthlyChartTitle: "Devis et Revenus Mensuels (12 Derniers Mois)",
    statusDistribution: "Répartition des Statuts",
    topCategoriesTitle: "Catégories les Plus Utilisées",
    noCategoryData: "Aucune donnée de catégorie pour le moment",
    itemsWord: "articles",
    topCustomersTitle: "Revenus par Client (Top 10)",
    noCustomerData: "Aucune donnée client pour le moment",
    reportsLoadFailed: "Les données du rapport n'ont pas pu être chargées",

    // Smart fields
    categoryLabel: "Catégorie",
    selectCategoryPlaceholder: "Sélectionner la catégorie",
    subCategoryLabel: "Sous-catégorie",
    selectSubCategoryPlaceholder: "Sélectionner la sous-catégorie",
    detailLabel: "Détail / Caractéristique",
    selectDetailPlaceholder: "Sélectionner le détail",
    measureCalcLabel: "Calculer par Mesure (mètres)",
    widthLabel: "Largeur",
    lengthLabel: "Longueur",
    heightLabel: "Hauteur",
    heightOptLabel: "Hauteur (opt.)",
    autoTransferred: "Transféré automatiquement à la quantité",
    hideCalcTable: "Masquer le Tableau de Calcul",
    getPriceBtn: "Obtenir le Prix",
    gettingPrice: "Obtention du prix...",
    enterItemFirst: "Saisissez d'abord un nom d'article ou sélectionnez une catégorie",
    aiPriceFailed: "L'estimation de prix IA n'a pas pu être récupérée, veuillez réessayer",
    noPriceToApply: "Aucun prix trouvé à appliquer",
    priceApplied: "Prix unitaire appliqué",
    applyMaterialBtn: "Appliquer le Matériau",
    applyLaborBtn: "Appliquer la Main-d'œuvre",
    avgLabel: "Moy",

    // Reset password
    newPasswordTitle: "Définir un Nouveau Mot de Passe",
    newPasswordDesc: "Créez un nouveau mot de passe pour votre compte",
    invalidLink: "Lien Invalide",
    invalidLinkDesc: "Le lien de réinitialisation du mot de passe est invalide ou manquant. Veuillez demander une nouvelle réinitialisation.",
    backToHome: "Retour à l'Accueil",
    changePasswordBtn: "Changer le Mot de Passe",
    passwordResetSuccess: "Votre mot de passe a été changé avec succès !",
    passwordResetFailed: "Échec de la réinitialisation. Le lien peut être invalide ou expiré.",

    // Landing extras
    featureMaterialTitle: "Gestion des Matériaux",
    featureMaterialDesc: "Listes détaillées de matériaux, prix unitaires, images et calcul automatique des totaux.",
    featureLaborTitle: "Main-d'œuvre et TVA",
    featureLaborDesc: "Coûts de main-d'œuvre, calculs de TVA et gestion des commissions sur une seule plateforme.",
    featurePdfTitle: "Export PDF",
    featurePdfDesc: "Sorties PDF professionnelles, prêtes avec logo d'entreprise et informations client.",
    footerDesc: "Plateforme professionnelle de préparation de devis. Réalisez facilement vos calculs de matériaux, de main-d'œuvre et de coûts.",
    footerRights: "© 2025 NKT Design. Tous droits réservés.",
    helpTitle: "Aide",
    contactUs: "Nous Contacter",
    faqLink: "Questions Fréquentes",
    supportLink: "Support",
    termsLink: "Termes et Conditions",
    servicesTitle: "Services",
    serviceLaborKdv: "Calcul Main-d'œuvre et TVA",
    serviceCost: "Calcul des Coûts",
    servicePdfJpg: "Export PDF et JPG",
    communityTitle: "Communauté",
    footerSlogan: "Votre Partenaire de Confiance pour vos Projets de Design et Décoration",
    resetLinkSentKnown: "Un lien de réinitialisation a été envoyé à votre adresse e-mail",
    resetLinkSentGeneric: "Si l'adresse e-mail est enregistrée, un lien de réinitialisation a été envoyé",
    genericError: "Une erreur s'est produite",
    imageTooBig2MB: "L'image doit être inférieure à 2 Mo",

    // Auth & misc extras
    optionalWord: "(optionnel)",
    loginErrCreds: "E-mail ou mot de passe incorrect. Si vous avez oublié votre mot de passe, utilisez le lien 'Mot de passe oublié'.",
    loginErrNotFound: "Aucun utilisateur enregistré avec cette adresse e-mail. Veuillez d'abord vous inscrire via 'S'inscrire'.",
    loginErrNetwork: "Impossible de joindre le serveur. Vérifiez votre connexion internet ou réessayez sous peu.",
    loginErrGeneric: "Échec de la connexion",
    authSessionNotFound: "Session introuvable",
    authFailed: "Échec de l'authentification",
    authenticating: "Authentification...",
    authNotMe: "Ce n'est pas moi — se connecter avec un autre compte",
    authNotMeNote: "Si \"Ce n'est pas moi\" est sélectionné, la session Google sur cet appareil est fermée et les informations du compte seront redemandées à la prochaine connexion.",
    qtyApplied: "Quantité appliquée",
    calcEnterHint: "Saisissez les mesures — les résultats apparaîtront automatiquement",
    pdfOpenedPrintHint: "PDF ouvert. Vous pouvez l'imprimer depuis le menu du navigateur.",
    applyBtn: "Appliquer",
    applyToQuantity: "Appliquer à la Quantité",
    authContinueQuestion: "Voulez-vous continuer avec ce compte ?",
    authContinueYes: "Oui, Continuer",
    wallAreaFormula: "Surface murale = 2×(Largeur+Longueur)×Hauteur",
    termsConditions: "Termes et Conditions",
    singleWallFormula: "Mur simple = Largeur×Hauteur",
    floorAreaFormula: "Surface au sol = Largeur×Longueur"
  }
};

// Date locales per language
export const dateLocales = {
  tr: "tr-TR",
  en: "en-GB",
  es: "es-ES",
  ar: "ar-EG",
  fr: "fr-FR"
};

// Language names for display
export const languageNames = {
  tr: { name: "Türkçe", flag: "🇹🇷" },
  en: { name: "English", flag: "🇬🇧" },
  es: { name: "Español", flag: "🇪🇸" },
  ar: { name: "العربية", flag: "🇸🇦", rtl: true },
  fr: { name: "Français", flag: "🇫🇷" }
};

// Get translation function
export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['tr'][key] || key;
};

// Hook for using translations
export const useTranslation = (lang) => {
  const t = (key) => getTranslation(lang, key);
  return { t, lang };
};

export default translations;
